var map = {
	"./__TypePolicies": [
		85618,
		3,
		85618
	],
	"./__TypePolicies.json": [
		85618,
		3,
		85618
	],
	"./__modules": [
		9479,
		9,
		9479
	],
	"./__modules.js": [
		9479,
		9,
		9479
	],
	"./_module_demo_/client/assets/images/thumbnail.jpg": [
		47120,
		1,
		47120
	],
	"./_module_demo_/client/graphql/item": [
		90902,
		9,
		90902
	],
	"./_module_demo_/client/graphql/item.js": [
		90902,
		9,
		90902
	],
	"./_module_demo_/client/graphql/settings": [
		86729,
		9
	],
	"./_module_demo_/client/graphql/settings.js": [
		86729,
		9
	],
	"./_module_demo_/client/scss/NavsAsideExtends.scss": [
		97318,
		9
	],
	"./_module_demo_/client/scss/index.scss": [
		8759,
		9
	],
	"./_module_demo_/client/scss/publicPage.scss": [
		15498,
		9,
		15498
	],
	"./_module_demo_/client/typePolicies": [
		44543,
		9,
		44543
	],
	"./_module_demo_/client/typePolicies.js": [
		44543,
		9,
		44543
	],
	"./_module_demo_/module": [
		83591,
		3
	],
	"./_module_demo_/module.json": [
		83591,
		3
	],
	"./_module_demo_/my/Dashboard": [
		81535,
		9,
		81535
	],
	"./_module_demo_/my/Dashboard.js": [
		81535,
		9,
		81535
	],
	"./_module_demo_/my/Emitters": [
		57937,
		9,
		57937
	],
	"./_module_demo_/my/Emitters.js": [
		57937,
		9,
		57937
	],
	"./_module_demo_/my/ModuleDemo": [
		51002,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		46851,
		35348,
		27508,
		63780,
		28492,
		28669,
		97994,
		75072,
		16599
	],
	"./_module_demo_/my/ModuleDemo.js": [
		51002,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		46851,
		35348,
		27508,
		63780,
		28492,
		28669,
		97994,
		75072,
		16599
	],
	"./_module_demo_/my/NavsAsideExtends": [
		37615,
		9
	],
	"./_module_demo_/my/NavsAsideExtends.js": [
		37615,
		9
	],
	"./_module_demo_/my/OtherPage": [
		96732,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		20232
	],
	"./_module_demo_/my/OtherPage.js": [
		96732,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		20232
	],
	"./_module_demo_/my/Settings": [
		44275,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		42823
	],
	"./_module_demo_/my/Settings.js": [
		44275,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		42823
	],
	"./_module_demo_/translation/en": [
		56536,
		3
	],
	"./_module_demo_/translation/en.json": [
		56536,
		3
	],
	"./_module_demo_/translation/it": [
		22826,
		3
	],
	"./_module_demo_/translation/it.json": [
		22826,
		3
	],
	"./_module_demo_/web": [
		93709,
		9,
		12696,
		93709
	],
	"./_module_demo_/web/": [
		93709,
		9,
		12696,
		93709
	],
	"./_module_demo_/web/Emitters": [
		54594,
		9,
		54594
	],
	"./_module_demo_/web/Emitters.js": [
		54594,
		9,
		54594
	],
	"./_module_demo_/web/PublicPage": [
		72247,
		9,
		12696,
		72247
	],
	"./_module_demo_/web/PublicPage.js": [
		72247,
		9,
		12696,
		72247
	],
	"./_module_demo_/web/index": [
		93709,
		9,
		12696,
		93709
	],
	"./_module_demo_/web/index.js": [
		93709,
		9,
		12696,
		93709
	],
	"./assistant/client/scss/index.scss": [
		11777,
		9
	],
	"./assistant/client/typePolicies": [
		7231,
		9,
		7231
	],
	"./assistant/client/typePolicies.js": [
		7231,
		9,
		7231
	],
	"./assistant/client/utils": [
		78842,
		9
	],
	"./assistant/client/utils/": [
		78842,
		9
	],
	"./assistant/client/utils/index": [
		78842,
		9
	],
	"./assistant/client/utils/index.js": [
		78842,
		9
	],
	"./assistant/module": [
		66249,
		3
	],
	"./assistant/module.json": [
		66249,
		3
	],
	"./assistant/my/Assistant": [
		45619,
		9
	],
	"./assistant/my/Assistant.js": [
		45619,
		9
	],
	"./assistant/my/Dashboard": [
		51246,
		9,
		51246
	],
	"./assistant/my/Dashboard.js": [
		51246,
		9,
		51246
	],
	"./assistant/translation/en": [
		97700,
		3
	],
	"./assistant/translation/en.json": [
		97700,
		3
	],
	"./assistant/translation/it": [
		53930,
		3
	],
	"./assistant/translation/it.json": [
		53930,
		3
	],
	"./consumer/client/graphql": [
		70736,
		9,
		70736
	],
	"./consumer/client/graphql/": [
		70736,
		9,
		70736
	],
	"./consumer/client/graphql/consumer": [
		35888,
		9,
		35888
	],
	"./consumer/client/graphql/consumer.js": [
		35888,
		9,
		35888
	],
	"./consumer/client/graphql/index": [
		70736,
		9,
		70736
	],
	"./consumer/client/graphql/index.js": [
		70736,
		9,
		70736
	],
	"./consumer/module": [
		59328,
		3
	],
	"./consumer/module.json": [
		59328,
		3
	],
	"./consumer/test/asyncHooks.cjs": [
		38117,
		1,
		38117
	],
	"./consumer/test/jest.config.cjs": [
		22736,
		1,
		22736
	],
	"./consumer/test/setup.cjs": [
		81258,
		1,
		81258
	],
	"./consumer/translation/en": [
		54766,
		3
	],
	"./consumer/translation/en.json": [
		54766,
		3
	],
	"./consumer/translation/it": [
		16920,
		3
	],
	"./consumer/translation/it.json": [
		16920,
		3
	],
	"./consumer/utils/consumerProfileMetadata": [
		49911,
		9,
		49911
	],
	"./consumer/utils/consumerProfileMetadata.js": [
		49911,
		9,
		49911
	],
	"./consumer/utils/urlBuilder": [
		17765,
		9,
		17765
	],
	"./consumer/utils/urlBuilder.js": [
		17765,
		9,
		17765
	],
	"./consumer/web": [
		25637,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28669,
		97994,
		58762,
		12696,
		75072,
		50385,
		99536,
		11001,
		25637
	],
	"./consumer/web/": [
		25637,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28669,
		97994,
		58762,
		12696,
		75072,
		50385,
		99536,
		11001,
		25637
	],
	"./consumer/web/ConsumerAuthPage": [
		11001,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		10670,
		28669,
		12696,
		11001,
		60204
	],
	"./consumer/web/ConsumerAuthPage.js": [
		11001,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		10670,
		28669,
		12696,
		11001,
		60204
	],
	"./consumer/web/ConsumerCareerPoints": [
		23593,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28669,
		97994,
		75072,
		50385,
		23593
	],
	"./consumer/web/ConsumerCareerPoints.js": [
		23593,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28669,
		97994,
		75072,
		50385,
		23593
	],
	"./consumer/web/ConsumerProfilePage": [
		95922,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28669,
		97994,
		58762,
		12696,
		75072,
		50385,
		95922
	],
	"./consumer/web/ConsumerProfilePage.js": [
		95922,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28669,
		97994,
		58762,
		12696,
		75072,
		50385,
		95922
	],
	"./consumer/web/index": [
		25637,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28669,
		97994,
		58762,
		12696,
		75072,
		50385,
		99536,
		11001,
		25637
	],
	"./consumer/web/index.js": [
		25637,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28669,
		97994,
		58762,
		12696,
		75072,
		50385,
		99536,
		11001,
		25637
	],
	"./consumer/web/utils/consumerApolloContext": [
		44827,
		9,
		44827
	],
	"./consumer/web/utils/consumerApolloContext.js": [
		44827,
		9,
		44827
	],
	"./consumer/web/utils/consumerAuthReturnTarget": [
		99559,
		9,
		99559
	],
	"./consumer/web/utils/consumerAuthReturnTarget.js": [
		99559,
		9,
		99559
	],
	"./consumer/web/utils/consumerPendingClaimHandoff": [
		56933,
		9,
		56933
	],
	"./consumer/web/utils/consumerPendingClaimHandoff.js": [
		56933,
		9,
		56933
	],
	"./consumer/web/utils/consumerPendingClaimStorage": [
		2152,
		9,
		2152
	],
	"./consumer/web/utils/consumerPendingClaimStorage.js": [
		2152,
		9,
		2152
	],
	"./consumer/web/utils/consumerSessionStorage": [
		43409,
		9,
		43409
	],
	"./consumer/web/utils/consumerSessionStorage.js": [
		43409,
		9,
		43409
	],
	"./dashboard/client/scss/index.scss": [
		38935,
		9
	],
	"./dashboard/components/AllDashboards": [
		79132,
		9,
		79132
	],
	"./dashboard/components/AllDashboards.js": [
		79132,
		9,
		79132
	],
	"./dashboard/module": [
		44917,
		3
	],
	"./dashboard/module.json": [
		44917,
		3
	],
	"./dashboard/my/Dashboard": [
		93624,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		48424,
		19423
	],
	"./dashboard/my/Dashboard.js": [
		93624,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		48424,
		19423
	],
	"./dashboard/translation/en": [
		18784,
		3
	],
	"./dashboard/translation/en.json": [
		18784,
		3
	],
	"./dashboard/translation/it": [
		22738,
		3
	],
	"./dashboard/translation/it.json": [
		22738,
		3
	],
	"./kitchen-order-ticket/client/assets/images/betwixt-gestione-comande-cucina.png": [
		85024,
		1,
		85024
	],
	"./kitchen-order-ticket/client/assets/images/betwixt-gestione-menu-ordinabile.png": [
		74001,
		1,
		74001
	],
	"./kitchen-order-ticket/client/assets/images/betwixt-hours-for-reservations.png": [
		77035,
		1,
		77035
	],
	"./kitchen-order-ticket/client/assets/images/betwixt-order-calendar.png": [
		80391,
		1,
		80391
	],
	"./kitchen-order-ticket/client/assets/images/betwixt-preparation-time.png": [
		97417,
		1,
		97417
	],
	"./kitchen-order-ticket/client/assets/images/completed.svg": [
		50219,
		1,
		50219
	],
	"./kitchen-order-ticket/client/assets/images/landing-bg-top-2.jpg": [
		34122,
		1,
		34122
	],
	"./kitchen-order-ticket/client/assets/images/landing-bg-top.jpg": [
		18575,
		1,
		18575
	],
	"./kitchen-order-ticket/client/assets/images/thumbnail.jpg": [
		15783,
		1,
		15783
	],
	"./kitchen-order-ticket/client/assets/sounds/alert.mp3": [
		74582,
		1,
		74582
	],
	"./kitchen-order-ticket/client/graphql/kot": [
		38085,
		9,
		38085
	],
	"./kitchen-order-ticket/client/graphql/kot.js": [
		38085,
		9,
		38085
	],
	"./kitchen-order-ticket/client/graphql/location": [
		10084,
		9,
		10084
	],
	"./kitchen-order-ticket/client/graphql/location.js": [
		10084,
		9,
		10084
	],
	"./kitchen-order-ticket/client/graphql/settings": [
		99049,
		9
	],
	"./kitchen-order-ticket/client/graphql/settings.js": [
		99049,
		9
	],
	"./kitchen-order-ticket/client/graphql/table": [
		22260,
		9,
		22260
	],
	"./kitchen-order-ticket/client/graphql/table.js": [
		22260,
		9,
		22260
	],
	"./kitchen-order-ticket/client/scss/Table.scss": [
		73582,
		9,
		73582
	],
	"./kitchen-order-ticket/client/scss/TableDetails.scss": [
		33213,
		9,
		33213
	],
	"./kitchen-order-ticket/client/scss/Ticket.scss": [
		1854,
		9,
		1854
	],
	"./kitchen-order-ticket/client/scss/dashboard.scss": [
		58134,
		9,
		58134
	],
	"./kitchen-order-ticket/client/scss/index.scss": [
		87674,
		9
	],
	"./kitchen-order-ticket/client/scss/publicPage.scss": [
		29011,
		9,
		29011
	],
	"./kitchen-order-ticket/client/typePolicies": [
		52194,
		9,
		52194
	],
	"./kitchen-order-ticket/client/typePolicies.js": [
		52194,
		9,
		52194
	],
	"./kitchen-order-ticket/components/ModalSliderTickets": [
		26689,
		9,
		88084,
		95500,
		53145,
		26689
	],
	"./kitchen-order-ticket/components/ModalSliderTickets.js": [
		26689,
		9,
		88084,
		95500,
		53145,
		26689
	],
	"./kitchen-order-ticket/components/NewTicket": [
		6914,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		14451,
		27508,
		87941,
		96642,
		26815
	],
	"./kitchen-order-ticket/components/NewTicket.js": [
		6914,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		14451,
		27508,
		87941,
		96642,
		26815
	],
	"./kitchen-order-ticket/components/OpenHours": [
		57199,
		9,
		57199
	],
	"./kitchen-order-ticket/components/OpenHours.js": [
		57199,
		9,
		57199
	],
	"./kitchen-order-ticket/components/SliderTickets": [
		53145,
		9,
		88084,
		95500,
		53145
	],
	"./kitchen-order-ticket/components/SliderTickets.js": [
		53145,
		9,
		88084,
		95500,
		53145
	],
	"./kitchen-order-ticket/components/Table": [
		64642,
		9,
		88084,
		64642,
		65571
	],
	"./kitchen-order-ticket/components/Table.js": [
		64642,
		9,
		88084,
		64642,
		65571
	],
	"./kitchen-order-ticket/components/TableDetails": [
		12619,
		9,
		88084,
		12619
	],
	"./kitchen-order-ticket/components/TableDetails.js": [
		12619,
		9,
		88084,
		12619
	],
	"./kitchen-order-ticket/components/TableEdit": [
		11375,
		9,
		88084,
		11375
	],
	"./kitchen-order-ticket/components/TableEdit.js": [
		11375,
		9,
		88084,
		11375
	],
	"./kitchen-order-ticket/components/Ticket": [
		85581,
		9,
		88084,
		85581
	],
	"./kitchen-order-ticket/components/Ticket.js": [
		85581,
		9,
		88084,
		85581
	],
	"./kitchen-order-ticket/components/TicketActions": [
		24338,
		9,
		24338
	],
	"./kitchen-order-ticket/components/TicketActions.js": [
		24338,
		9,
		24338
	],
	"./kitchen-order-ticket/components/TicketHistory": [
		51065,
		9,
		88084,
		51065
	],
	"./kitchen-order-ticket/components/TicketHistory.js": [
		51065,
		9,
		88084,
		51065
	],
	"./kitchen-order-ticket/components/TicketItems": [
		85028,
		9,
		88084,
		85028
	],
	"./kitchen-order-ticket/components/TicketItems.js": [
		85028,
		9,
		88084,
		85028
	],
	"./kitchen-order-ticket/module": [
		58931,
		3
	],
	"./kitchen-order-ticket/module.json": [
		58931,
		3
	],
	"./kitchen-order-ticket/my/Dashboard": [
		4603,
		9,
		4603
	],
	"./kitchen-order-ticket/my/Dashboard.js": [
		4603,
		9,
		4603
	],
	"./kitchen-order-ticket/my/Emitters": [
		38109,
		9,
		38109
	],
	"./kitchen-order-ticket/my/Emitters.js": [
		38109,
		9,
		38109
	],
	"./kitchen-order-ticket/my/History": [
		81231,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		88084,
		28492,
		48877
	],
	"./kitchen-order-ticket/my/History.js": [
		81231,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		88084,
		28492,
		48877
	],
	"./kitchen-order-ticket/my/KitchenOrderTicket": [
		28279,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		35348,
		27508,
		88084,
		28492,
		87941,
		96642,
		95500,
		20711,
		53145,
		79279
	],
	"./kitchen-order-ticket/my/KitchenOrderTicket.js": [
		28279,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		35348,
		27508,
		88084,
		28492,
		87941,
		96642,
		95500,
		20711,
		53145,
		79279
	],
	"./kitchen-order-ticket/my/Settings": [
		39416,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		27508,
		63780,
		10670,
		28492,
		20711,
		32289,
		39416
	],
	"./kitchen-order-ticket/my/Settings.js": [
		39416,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		27508,
		63780,
		10670,
		28492,
		20711,
		32289,
		39416
	],
	"./kitchen-order-ticket/my/Tables": [
		94333,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		88084,
		28492,
		64642,
		50601
	],
	"./kitchen-order-ticket/my/Tables.js": [
		94333,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		88084,
		28492,
		64642,
		50601
	],
	"./kitchen-order-ticket/translation/en": [
		56910,
		3
	],
	"./kitchen-order-ticket/translation/en.json": [
		56910,
		3
	],
	"./kitchen-order-ticket/translation/it": [
		39406,
		3
	],
	"./kitchen-order-ticket/translation/it.json": [
		39406,
		3
	],
	"./kitchen-order-ticket/web": [
		70129,
		9,
		12696,
		5992
	],
	"./kitchen-order-ticket/web/": [
		70129,
		9,
		12696,
		5992
	],
	"./kitchen-order-ticket/web/Emitters": [
		72054,
		9,
		72054
	],
	"./kitchen-order-ticket/web/Emitters.js": [
		72054,
		9,
		72054
	],
	"./kitchen-order-ticket/web/PublicPage": [
		73847,
		9,
		12696,
		73847
	],
	"./kitchen-order-ticket/web/PublicPage.js": [
		73847,
		9,
		12696,
		73847
	],
	"./kitchen-order-ticket/web/index": [
		70129,
		9,
		12696,
		5992
	],
	"./kitchen-order-ticket/web/index.js": [
		70129,
		9,
		12696,
		5992
	],
	"./menu-management/client/assets/images/Allergen_celery.svg": [
		31202,
		1,
		31202
	],
	"./menu-management/client/assets/images/Allergen_celery_color.svg": [
		63931,
		1,
		63931
	],
	"./menu-management/client/assets/images/Allergen_crustaceans.svg": [
		73486,
		1,
		73486
	],
	"./menu-management/client/assets/images/Allergen_crustaceans_color.svg": [
		50525,
		1,
		50525
	],
	"./menu-management/client/assets/images/Allergen_egg.svg": [
		96282,
		1,
		96282
	],
	"./menu-management/client/assets/images/Allergen_egg_color.svg": [
		7176,
		1,
		7176
	],
	"./menu-management/client/assets/images/Allergen_fish.svg": [
		86790,
		1,
		86790
	],
	"./menu-management/client/assets/images/Allergen_fish_color.svg": [
		60361,
		1,
		60361
	],
	"./menu-management/client/assets/images/Allergen_gluten_wheat.svg": [
		42820,
		1,
		42820
	],
	"./menu-management/client/assets/images/Allergen_gluten_wheat_color.svg": [
		97628,
		1,
		97628
	],
	"./menu-management/client/assets/images/Allergen_lupin.svg": [
		40219,
		1,
		40219
	],
	"./menu-management/client/assets/images/Allergen_lupin_color.svg": [
		75842,
		1,
		75842
	],
	"./menu-management/client/assets/images/Allergen_milk.svg": [
		98090,
		1,
		98090
	],
	"./menu-management/client/assets/images/Allergen_milk_color.svg": [
		46392,
		1,
		46392
	],
	"./menu-management/client/assets/images/Allergen_minimal_celery.svg": [
		77834,
		1,
		77834
	],
	"./menu-management/client/assets/images/Allergen_minimal_crustaceans.svg": [
		75216,
		1,
		75216
	],
	"./menu-management/client/assets/images/Allergen_minimal_egg.svg": [
		67003,
		1,
		67003
	],
	"./menu-management/client/assets/images/Allergen_minimal_fish.svg": [
		46713,
		1,
		46713
	],
	"./menu-management/client/assets/images/Allergen_minimal_gluten_wheat.svg": [
		74338,
		1,
		74338
	],
	"./menu-management/client/assets/images/Allergen_minimal_lupin.svg": [
		58275,
		1,
		58275
	],
	"./menu-management/client/assets/images/Allergen_minimal_milk.svg": [
		52702,
		1,
		52702
	],
	"./menu-management/client/assets/images/Allergen_minimal_mollusks.svg": [
		55969,
		1,
		55969
	],
	"./menu-management/client/assets/images/Allergen_minimal_mustard.svg": [
		18136,
		1,
		18136
	],
	"./menu-management/client/assets/images/Allergen_minimal_peanuts.svg": [
		50168,
		1,
		50168
	],
	"./menu-management/client/assets/images/Allergen_minimal_sesame.svg": [
		44097,
		1,
		44097
	],
	"./menu-management/client/assets/images/Allergen_minimal_soy.svg": [
		69570,
		1,
		69570
	],
	"./menu-management/client/assets/images/Allergen_minimal_sulfur_dioxide.svg": [
		12485,
		1,
		12485
	],
	"./menu-management/client/assets/images/Allergen_minimal_tree_nuts.svg": [
		7066,
		1,
		7066
	],
	"./menu-management/client/assets/images/Allergen_mollusks.svg": [
		18662,
		1,
		18662
	],
	"./menu-management/client/assets/images/Allergen_mollusks_color.svg": [
		26495,
		1,
		26495
	],
	"./menu-management/client/assets/images/Allergen_mustard.svg": [
		31774,
		1,
		31774
	],
	"./menu-management/client/assets/images/Allergen_mustard_color.svg": [
		29323,
		1,
		29323
	],
	"./menu-management/client/assets/images/Allergen_peanuts.svg": [
		24665,
		1,
		24665
	],
	"./menu-management/client/assets/images/Allergen_peanuts_color.svg": [
		15712,
		1,
		15712
	],
	"./menu-management/client/assets/images/Allergen_sesame.svg": [
		71467,
		1,
		71467
	],
	"./menu-management/client/assets/images/Allergen_sesame_color.svg": [
		14358,
		1,
		14358
	],
	"./menu-management/client/assets/images/Allergen_soy.svg": [
		40302,
		1,
		40302
	],
	"./menu-management/client/assets/images/Allergen_soy_color.svg": [
		39648,
		1,
		39648
	],
	"./menu-management/client/assets/images/Allergen_sulfur_dioxide.svg": [
		44022,
		1,
		44022
	],
	"./menu-management/client/assets/images/Allergen_sulfur_dioxide_color.svg": [
		42265,
		1,
		42265
	],
	"./menu-management/client/assets/images/Allergen_tree_nuts.svg": [
		36805,
		1,
		36805
	],
	"./menu-management/client/assets/images/Allergen_tree_nuts_color.svg": [
		41354,
		1,
		41354
	],
	"./menu-management/client/assets/images/Allergens_AF_more.svg": [
		15723,
		1,
		15723
	],
	"./menu-management/client/assets/images/EDC3A61041C44119.png": [
		99502,
		1,
		99502
	],
	"./menu-management/client/assets/images/FoodType_100_vegan.svg": [
		55650,
		1,
		55650
	],
	"./menu-management/client/assets/images/FoodType_biological.svg": [
		88741,
		1,
		88741
	],
	"./menu-management/client/assets/images/FoodType_frozen.svg": [
		9848,
		1,
		9848
	],
	"./menu-management/client/assets/images/FoodType_gluten_free.svg": [
		51245,
		1,
		51245
	],
	"./menu-management/client/assets/images/FoodType_lactose_free.svg": [
		53803,
		1,
		53803
	],
	"./menu-management/client/assets/images/FoodType_pulled_down.svg": [
		78465,
		1,
		78465
	],
	"./menu-management/client/assets/images/FoodType_spicy.svg": [
		1187,
		1,
		1187
	],
	"./menu-management/client/assets/images/FoodType_vegetarian.svg": [
		9474,
		1,
		9474
	],
	"./menu-management/client/assets/images/pp_allergens.png": [
		83286,
		1,
		83286
	],
	"./menu-management/client/assets/images/pp_local_with_tablet.jpg": [
		55070,
		1,
		55070
	],
	"./menu-management/client/assets/images/pp_menu_list.png": [
		46524,
		1,
		46524
	],
	"./menu-management/client/assets/images/pp_plate_detail.png": [
		91805,
		1,
		91805
	],
	"./menu-management/client/assets/images/pp_plates.png": [
		99067,
		1,
		99067
	],
	"./menu-management/client/assets/images/pp_prices_on_menus.png": [
		56300,
		1,
		56300
	],
	"./menu-management/client/assets/images/pp_switch.svg": [
		6502,
		1,
		6502
	],
	"./menu-management/client/assets/images/pp_types.png": [
		11545,
		1,
		11545
	],
	"./menu-management/client/assets/images/qr_double.svg": [
		71144,
		1,
		71144
	],
	"./menu-management/client/assets/images/qr_multiple.svg": [
		9842,
		1,
		9842
	],
	"./menu-management/client/assets/images/qr_single.svg": [
		1478,
		1,
		1478
	],
	"./menu-management/client/assets/images/thumbnail.jpg": [
		86741,
		1,
		86741
	],
	"./menu-management/client/graphql/assistant": [
		42253,
		9,
		42253
	],
	"./menu-management/client/graphql/assistant.js": [
		42253,
		9,
		42253
	],
	"./menu-management/client/graphql/composition": [
		96595,
		9,
		96595
	],
	"./menu-management/client/graphql/composition.js": [
		96595,
		9,
		96595
	],
	"./menu-management/client/graphql/dashboard": [
		92636,
		9,
		92636
	],
	"./menu-management/client/graphql/dashboard.js": [
		92636,
		9,
		92636
	],
	"./menu-management/client/graphql/element": [
		51305,
		9,
		51305
	],
	"./menu-management/client/graphql/element.js": [
		51305,
		9,
		51305
	],
	"./menu-management/client/graphql/facebook": [
		21502,
		9,
		21502
	],
	"./menu-management/client/graphql/facebook.js": [
		21502,
		9,
		21502
	],
	"./menu-management/client/graphql/item": [
		63516,
		9,
		63516
	],
	"./menu-management/client/graphql/item.js": [
		63516,
		9,
		63516
	],
	"./menu-management/client/graphql/menu": [
		43426,
		9,
		43426
	],
	"./menu-management/client/graphql/menu.js": [
		43426,
		9,
		43426
	],
	"./menu-management/client/graphql/settings": [
		36071,
		9
	],
	"./menu-management/client/graphql/settings.js": [
		36071,
		9
	],
	"./menu-management/client/scss/AllergensAndFoodType.scss": [
		94942,
		9,
		94942
	],
	"./menu-management/client/scss/NavsAsideExtends.scss": [
		87044,
		9
	],
	"./menu-management/client/scss/QRCodePage.scss": [
		85964,
		9,
		85964
	],
	"./menu-management/client/scss/assistant.scss": [
		19071,
		9,
		19071
	],
	"./menu-management/client/scss/dashboard.scss": [
		53203,
		9,
		53203
	],
	"./menu-management/client/scss/index.scss": [
		79746,
		9
	],
	"./menu-management/client/scss/items.scss": [
		26241,
		9,
		26241
	],
	"./menu-management/client/scss/landingApi.scss": [
		75573,
		9,
		75573
	],
	"./menu-management/client/scss/landingWidget.scss": [
		42126,
		9,
		42126
	],
	"./menu-management/client/scss/menuSettings.scss": [
		33202,
		9,
		33202
	],
	"./menu-management/client/scss/menuShare.scss": [
		24859,
		9,
		24859
	],
	"./menu-management/client/scss/publicPage.scss": [
		62861,
		9,
		62861
	],
	"./menu-management/client/scss/publicPageLanding.scss": [
		65551,
		9,
		65551
	],
	"./menu-management/client/scss/userPublicPage.scss": [
		88798,
		9,
		88798
	],
	"./menu-management/client/typePolicies": [
		64874,
		9,
		67134
	],
	"./menu-management/client/typePolicies.js": [
		64874,
		9,
		67134
	],
	"./menu-management/client/utils/assistant": [
		13973,
		9,
		13973
	],
	"./menu-management/client/utils/assistant.js": [
		13973,
		9,
		13973
	],
	"./menu-management/client/utils/item": [
		81562,
		9,
		81562
	],
	"./menu-management/client/utils/item.js": [
		81562,
		9,
		81562
	],
	"./menu-management/client/utils/tag": [
		802,
		9,
		802
	],
	"./menu-management/client/utils/tag.js": [
		802,
		9,
		802
	],
	"./menu-management/components/AllergensAndFoodType": [
		94055,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		94055
	],
	"./menu-management/components/AllergensAndFoodType.js": [
		94055,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		94055
	],
	"./menu-management/components/FormCreate": [
		39883,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		27508,
		63780,
		10670,
		29567,
		6466
	],
	"./menu-management/components/FormCreate.js": [
		39883,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		27508,
		63780,
		10670,
		29567,
		6466
	],
	"./menu-management/components/ItemRow": [
		21343,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		27508,
		63780,
		77551,
		19119,
		61079,
		64874,
		36053
	],
	"./menu-management/components/ItemRow.js": [
		21343,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		27508,
		63780,
		77551,
		19119,
		61079,
		64874,
		36053
	],
	"./menu-management/components/ItemRowEdit": [
		70220,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		27508,
		63780,
		19119,
		61079,
		64874,
		36639
	],
	"./menu-management/components/ItemRowEdit.js": [
		70220,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		27508,
		63780,
		19119,
		61079,
		64874,
		36639
	],
	"./menu-management/components/ItemsList": [
		32494,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		27508,
		63780,
		77551,
		19119,
		61079,
		64874,
		77437
	],
	"./menu-management/components/ItemsList.js": [
		32494,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		27508,
		63780,
		77551,
		19119,
		61079,
		64874,
		77437
	],
	"./menu-management/components/MenuDetails": [
		29414,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		27508,
		63780,
		88084,
		10670,
		28492,
		77551,
		19119,
		61079,
		95500,
		20711,
		37124,
		29567,
		19604,
		66821,
		92821,
		64874,
		96844,
		31431
	],
	"./menu-management/components/MenuDetails.js": [
		29414,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		27508,
		63780,
		88084,
		10670,
		28492,
		77551,
		19119,
		61079,
		95500,
		20711,
		37124,
		29567,
		19604,
		66821,
		92821,
		64874,
		96844,
		31431
	],
	"./menu-management/components/MenuDetailsEdit": [
		54530,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		27508,
		63780,
		53514
	],
	"./menu-management/components/MenuDetailsEdit.js": [
		54530,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		27508,
		63780,
		53514
	],
	"./menu-management/components/MenuDetailsHistory": [
		38268,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		27508,
		63780,
		77551,
		19119,
		61079,
		95500,
		20711,
		64874,
		10782,
		8227
	],
	"./menu-management/components/MenuDetailsHistory.js": [
		38268,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		27508,
		63780,
		77551,
		19119,
		61079,
		95500,
		20711,
		64874,
		10782,
		8227
	],
	"./menu-management/components/MenuDetailsItems": [
		10782,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		27508,
		63780,
		77551,
		19119,
		61079,
		20711,
		64874,
		10782,
		19123
	],
	"./menu-management/components/MenuDetailsItems.js": [
		10782,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		27508,
		63780,
		77551,
		19119,
		61079,
		20711,
		64874,
		10782,
		19123
	],
	"./menu-management/components/MenuItem": [
		79766,
		9,
		79766
	],
	"./menu-management/components/MenuItem.js": [
		79766,
		9,
		79766
	],
	"./menu-management/components/MenuSettings": [
		87825,
		9,
		87825
	],
	"./menu-management/components/MenuSettings.js": [
		87825,
		9,
		87825
	],
	"./menu-management/components/MenuShare": [
		1059,
		9,
		66821,
		31864
	],
	"./menu-management/components/MenuShare.js": [
		1059,
		9,
		66821,
		31864
	],
	"./menu-management/components/MenuShare_Facebook": [
		82256,
		9,
		82256
	],
	"./menu-management/components/MenuShare_Facebook.js": [
		82256,
		9,
		82256
	],
	"./menu-management/components/MenuShare_PDF": [
		16213,
		9,
		66821,
		99521
	],
	"./menu-management/components/MenuShare_PDF.js": [
		16213,
		9,
		66821,
		99521
	],
	"./menu-management/components/MenusList": [
		55960,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		88084,
		28492,
		19119,
		37124,
		19604,
		96844,
		98353
	],
	"./menu-management/components/MenusList.js": [
		55960,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		88084,
		28492,
		19119,
		37124,
		19604,
		96844,
		98353
	],
	"./menu-management/components/SearchForm": [
		45947,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		46851,
		20025,
		81408,
		10670,
		29567,
		13382
	],
	"./menu-management/components/SearchForm.js": [
		45947,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		46851,
		20025,
		81408,
		10670,
		29567,
		13382
	],
	"./menu-management/components/Tags": [
		66369,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		46851,
		20025,
		81408,
		10670,
		29567,
		20637
	],
	"./menu-management/components/Tags.js": [
		66369,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		46851,
		20025,
		81408,
		10670,
		29567,
		20637
	],
	"./menu-management/components/UserPublicPage_scripts": [
		23425,
		9,
		23425
	],
	"./menu-management/components/UserPublicPage_scripts.js": [
		23425,
		9,
		23425
	],
	"./menu-management/components/_MM_Assistant": [
		68050,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		19119,
		37124,
		96844,
		36843
	],
	"./menu-management/components/_MM_Assistant.js": [
		68050,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		19119,
		37124,
		96844,
		36843
	],
	"./menu-management/components/assistant/TutorialBasic": [
		96844,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		19119,
		37124,
		96844,
		77805
	],
	"./menu-management/components/assistant/TutorialBasic.js": [
		96844,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		19119,
		37124,
		96844,
		77805
	],
	"./menu-management/module": [
		75373,
		3
	],
	"./menu-management/module.json": [
		75373,
		3
	],
	"./menu-management/my/Dashboard": [
		3692,
		9,
		3692
	],
	"./menu-management/my/Dashboard.js": [
		3692,
		9,
		3692
	],
	"./menu-management/my/MenuManagement": [
		22596,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		27508,
		63780,
		88084,
		10670,
		28492,
		77551,
		19119,
		61079,
		95500,
		20711,
		37124,
		29567,
		19604,
		66821,
		92821,
		64874,
		96844,
		45759
	],
	"./menu-management/my/MenuManagement.js": [
		22596,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		27508,
		63780,
		88084,
		10670,
		28492,
		77551,
		19119,
		61079,
		95500,
		20711,
		37124,
		29567,
		19604,
		66821,
		92821,
		64874,
		96844,
		45759
	],
	"./menu-management/my/NavsAsideExtends": [
		71356,
		9
	],
	"./menu-management/my/NavsAsideExtends.js": [
		71356,
		9
	],
	"./menu-management/my/QRCodePage": [
		38738,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		19454,
		51802,
		98134
	],
	"./menu-management/my/QRCodePage.js": [
		38738,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		19454,
		51802,
		98134
	],
	"./menu-management/my/Settings": [
		61709,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		27508,
		63780,
		10670,
		28492,
		19119,
		20711,
		37124,
		32289,
		96844,
		22718
	],
	"./menu-management/my/Settings.js": [
		61709,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		27508,
		63780,
		10670,
		28492,
		19119,
		20711,
		37124,
		32289,
		96844,
		22718
	],
	"./menu-management/my/composition": [
		40535,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		27508,
		63780,
		10670,
		28492,
		77551,
		19119,
		61079,
		95500,
		37124,
		29567,
		19604,
		64874,
		96844,
		39016,
		35901
	],
	"./menu-management/my/composition.js": [
		40535,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		27508,
		63780,
		10670,
		28492,
		77551,
		19119,
		61079,
		95500,
		37124,
		29567,
		19604,
		64874,
		96844,
		39016,
		35901
	],
	"./menu-management/my/element": [
		69228,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		27508,
		63780,
		10670,
		28492,
		77551,
		19119,
		61079,
		95500,
		37124,
		29567,
		19604,
		64874,
		96844,
		39016,
		28168
	],
	"./menu-management/my/element.js": [
		69228,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		27508,
		63780,
		10670,
		28492,
		77551,
		19119,
		61079,
		95500,
		37124,
		29567,
		19604,
		64874,
		96844,
		39016,
		28168
	],
	"./menu-management/translation/en": [
		78504,
		3
	],
	"./menu-management/translation/en.json": [
		78504,
		3
	],
	"./menu-management/translation/it": [
		39771,
		3
	],
	"./menu-management/translation/it.json": [
		39771,
		3
	],
	"./menu-management/utils/orderabledMenu": [
		28123,
		9,
		28123
	],
	"./menu-management/utils/orderabledMenu.js": [
		28123,
		9,
		28123
	],
	"./menu-management/web": [
		71636,
		9,
		12696,
		38979,
		28533
	],
	"./menu-management/web/": [
		71636,
		9,
		12696,
		38979,
		28533
	],
	"./menu-management/web/Emitters": [
		91139,
		9,
		91139
	],
	"./menu-management/web/Emitters.js": [
		91139,
		9,
		91139
	],
	"./menu-management/web/LandingApi": [
		65004,
		9,
		12696,
		65004
	],
	"./menu-management/web/LandingApi.js": [
		65004,
		9,
		12696,
		65004
	],
	"./menu-management/web/LandingWidget": [
		63428,
		9,
		12696,
		63428
	],
	"./menu-management/web/LandingWidget.js": [
		63428,
		9,
		12696,
		63428
	],
	"./menu-management/web/PublicPage": [
		38979,
		9,
		12696,
		38979,
		52514
	],
	"./menu-management/web/PublicPage.js": [
		38979,
		9,
		12696,
		38979,
		52514
	],
	"./menu-management/web/PublicPageLanding": [
		36435,
		9,
		12696,
		36435
	],
	"./menu-management/web/PublicPageLanding.js": [
		36435,
		9,
		12696,
		36435
	],
	"./menu-management/web/UserPublicPage": [
		89552,
		9,
		12696,
		89552
	],
	"./menu-management/web/UserPublicPage.js": [
		89552,
		9,
		12696,
		89552
	],
	"./menu-management/web/index": [
		71636,
		9,
		12696,
		38979,
		28533
	],
	"./menu-management/web/index.js": [
		71636,
		9,
		12696,
		38979,
		28533
	],
	"./profile/client/scss/index.scss": [
		81904,
		9
	],
	"./profile/module": [
		31553,
		3
	],
	"./profile/module.json": [
		31553,
		3
	],
	"./profile/my/Profile": [
		93185,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		35212
	],
	"./profile/my/Profile.js": [
		93185,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		35212
	],
	"./profile/translation/en": [
		19470,
		3
	],
	"./profile/translation/en.json": [
		19470,
		3
	],
	"./profile/translation/it": [
		66678,
		3
	],
	"./profile/translation/it.json": [
		66678,
		3
	],
	"./settings/client/graphql/facebook": [
		5725,
		9,
		5725
	],
	"./settings/client/graphql/facebook.js": [
		5725,
		9,
		5725
	],
	"./settings/client/scss/index.scss": [
		84073,
		9
	],
	"./settings/client/typePolicies": [
		85930,
		9,
		85930
	],
	"./settings/client/typePolicies.js": [
		85930,
		9,
		85930
	],
	"./settings/components/ImageBrand": [
		7841,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		19119,
		61079,
		47683
	],
	"./settings/components/ImageBrand.js": [
		7841,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		19119,
		61079,
		47683
	],
	"./settings/components/Profile": [
		40122,
		9,
		40122
	],
	"./settings/components/Profile.js": [
		40122,
		9,
		40122
	],
	"./settings/components/RefreshPWA": [
		32551,
		9,
		32551
	],
	"./settings/components/RefreshPWA.js": [
		32551,
		9,
		32551
	],
	"./settings/module": [
		28766,
		3
	],
	"./settings/module.json": [
		28766,
		3
	],
	"./settings/my/Settings": [
		46213,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		19119,
		61079,
		98746
	],
	"./settings/my/Settings.js": [
		46213,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		19119,
		61079,
		98746
	],
	"./settings/translation/en": [
		38097,
		3
	],
	"./settings/translation/en.json": [
		38097,
		3
	],
	"./settings/translation/it": [
		78449,
		3
	],
	"./settings/translation/it.json": [
		78449,
		3
	],
	"./shop/client/assets/images/sporthub/sporthub_logo_06_transparent.png": [
		32956,
		1,
		32956
	],
	"./shop/client/assets/images/sporthub/sporthub_logo_11_transparent.png": [
		56824,
		1,
		56824
	],
	"./shop/client/assets/images/stripe-logo.png": [
		48653,
		1,
		48653
	],
	"./shop/client/scss/CardSectionStyles.scss": [
		50401,
		9,
		50401
	],
	"./shop/client/scss/index.scss": [
		92328,
		9
	],
	"./shop/client/utils": [
		96360,
		9,
		96360
	],
	"./shop/client/utils/": [
		96360,
		9,
		96360
	],
	"./shop/client/utils/index": [
		96360,
		9,
		96360
	],
	"./shop/client/utils/index.js": [
		96360,
		9,
		96360
	],
	"./shop/components/CardSection": [
		10903,
		9,
		4418,
		10903
	],
	"./shop/components/CardSection.js": [
		10903,
		9,
		4418,
		10903
	],
	"./shop/components/Checkout": [
		98851,
		9,
		58135,
		93288,
		4016,
		74556,
		14451,
		20025,
		81408,
		10670,
		4418,
		88506,
		6521,
		85439
	],
	"./shop/components/Checkout.js": [
		98851,
		9,
		58135,
		93288,
		4016,
		74556,
		14451,
		20025,
		81408,
		10670,
		4418,
		88506,
		6521,
		85439
	],
	"./shop/components/CheckoutForm": [
		6521,
		9,
		58135,
		93288,
		4016,
		74556,
		14451,
		20025,
		81408,
		10670,
		4418,
		88506,
		6521,
		96178
	],
	"./shop/components/CheckoutForm.js": [
		6521,
		9,
		58135,
		93288,
		4016,
		74556,
		14451,
		20025,
		81408,
		10670,
		4418,
		88506,
		6521,
		96178
	],
	"./shop/components/ModuleItem": [
		3250,
		9,
		3250
	],
	"./shop/components/ModuleItem.js": [
		3250,
		9,
		3250
	],
	"./shop/components/ModuleList": [
		17531,
		9,
		17531
	],
	"./shop/components/ModuleList.js": [
		17531,
		9,
		17531
	],
	"./shop/module": [
		94134,
		3
	],
	"./shop/module.json": [
		94134,
		3
	],
	"./shop/my/Shop": [
		15045,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		10670,
		28492,
		4418,
		88506,
		6521,
		39084
	],
	"./shop/my/Shop.js": [
		15045,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		10670,
		28492,
		4418,
		88506,
		6521,
		39084
	],
	"./shop/translation/en": [
		4346,
		3
	],
	"./shop/translation/en.json": [
		4346,
		3
	],
	"./shop/translation/it": [
		82516,
		3
	],
	"./shop/translation/it.json": [
		82516,
		3
	],
	"./sport-hub-club/README.md": [
		84226,
		1,
		84226
	],
	"./sport-hub-club/client/assets/images/thumbnail.jpg": [
		54533,
		1,
		54533
	],
	"./sport-hub-club/client/graphql": [
		22684,
		9,
		22684
	],
	"./sport-hub-club/client/graphql/": [
		22684,
		9,
		22684
	],
	"./sport-hub-club/client/graphql/fragments": [
		9907,
		9,
		9907
	],
	"./sport-hub-club/client/graphql/fragments.js": [
		9907,
		9,
		9907
	],
	"./sport-hub-club/client/graphql/index": [
		22684,
		9,
		22684
	],
	"./sport-hub-club/client/graphql/index.js": [
		22684,
		9,
		22684
	],
	"./sport-hub-club/client/graphql/mutations": [
		23006,
		9,
		23006
	],
	"./sport-hub-club/client/graphql/mutations.js": [
		23006,
		9,
		23006
	],
	"./sport-hub-club/client/graphql/queries": [
		39170,
		9,
		39170
	],
	"./sport-hub-club/client/graphql/queries.js": [
		39170,
		9,
		39170
	],
	"./sport-hub-club/client/scss/index.scss": [
		70355,
		9
	],
	"./sport-hub-club/client/scss/publicPage.scss": [
		28226,
		9,
		59632,
		28226
	],
	"./sport-hub-club/module": [
		95872,
		3
	],
	"./sport-hub-club/module.json": [
		95872,
		3
	],
	"./sport-hub-club/my/ClubCustomerCourseEnrollmentDrawer": [
		65580,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		40029,
		27508,
		63780,
		88084,
		10670,
		24968,
		30154,
		10723,
		87941,
		96642,
		75443
	],
	"./sport-hub-club/my/ClubCustomerCourseEnrollmentDrawer.js": [
		65580,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		40029,
		27508,
		63780,
		88084,
		10670,
		24968,
		30154,
		10723,
		87941,
		96642,
		75443
	],
	"./sport-hub-club/my/ClubCustomerCoursesTab": [
		50768,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28669,
		24968,
		30154,
		10723,
		87941,
		96642,
		89986,
		25620
	],
	"./sport-hub-club/my/ClubCustomerCoursesTab.js": [
		50768,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28669,
		24968,
		30154,
		10723,
		87941,
		96642,
		89986,
		25620
	],
	"./sport-hub-club/my/ClubCustomerPackagesTab": [
		55275,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28669,
		24968,
		30154,
		10723,
		23224,
		89986,
		55275,
		41218
	],
	"./sport-hub-club/my/ClubCustomerPackagesTab.js": [
		55275,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28669,
		24968,
		30154,
		10723,
		23224,
		89986,
		55275,
		41218
	],
	"./sport-hub-club/my/ClubLoyaltiesTable": [
		36092,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		88084,
		28669,
		30154,
		10838,
		32794,
		21456
	],
	"./sport-hub-club/my/ClubLoyaltiesTable.js": [
		36092,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		88084,
		28669,
		30154,
		10838,
		32794,
		21456
	],
	"./sport-hub-club/my/ClubLoyaltyAssignDrawer": [
		87843,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		40029,
		27508,
		63780,
		10670,
		24968,
		30154,
		10723,
		69376
	],
	"./sport-hub-club/my/ClubLoyaltyAssignDrawer.js": [
		87843,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		40029,
		27508,
		63780,
		10670,
		24968,
		30154,
		10723,
		69376
	],
	"./sport-hub-club/my/ClubLoyaltyDetail": [
		33984,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		70776,
		6779,
		30305
	],
	"./sport-hub-club/my/ClubLoyaltyDetail.js": [
		33984,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		70776,
		6779,
		30305
	],
	"./sport-hub-club/my/ClubPackagePurchaseDrawer": [
		80400,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		40029,
		27508,
		63780,
		10670,
		24968,
		30154,
		10723,
		157
	],
	"./sport-hub-club/my/ClubPackagePurchaseDrawer.js": [
		80400,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		40029,
		27508,
		63780,
		10670,
		24968,
		30154,
		10723,
		157
	],
	"./sport-hub-club/my/CourseDetail": [
		8612,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		30154,
		97994,
		10723,
		77551,
		70776,
		74066,
		87941,
		6779,
		96642,
		8612,
		22861
	],
	"./sport-hub-club/my/CourseDetail.js": [
		8612,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		30154,
		97994,
		10723,
		77551,
		70776,
		74066,
		87941,
		6779,
		96642,
		8612,
		22861
	],
	"./sport-hub-club/my/CourseSessionManager": [
		49586,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		97994,
		10723,
		58762,
		77551,
		70776,
		6779,
		32908,
		58117,
		27790,
		49586,
		1488
	],
	"./sport-hub-club/my/CourseSessionManager.js": [
		49586,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		97994,
		10723,
		58762,
		77551,
		70776,
		6779,
		32908,
		58117,
		27790,
		49586,
		1488
	],
	"./sport-hub-club/my/CoursesTable": [
		1715,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		28669,
		10838,
		18937
	],
	"./sport-hub-club/my/CoursesTable.js": [
		1715,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		28669,
		10838,
		18937
	],
	"./sport-hub-club/my/PackagesTable": [
		37682,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		88084,
		28669,
		30154,
		10838,
		32794,
		20962
	],
	"./sport-hub-club/my/PackagesTable.js": [
		37682,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		88084,
		28669,
		30154,
		10838,
		32794,
		20962
	],
	"./sport-hub-club/my/SportHubClub": [
		29678,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		70776,
		74066,
		87941,
		6779,
		96642,
		8612,
		29678,
		55675
	],
	"./sport-hub-club/my/SportHubClub.js": [
		29678,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		70776,
		74066,
		87941,
		6779,
		96642,
		8612,
		29678,
		55675
	],
	"./sport-hub-club/my/clubDrawerUtils": [
		31122,
		9,
		31122
	],
	"./sport-hub-club/my/clubDrawerUtils.js": [
		31122,
		9,
		31122
	],
	"./sport-hub-club/my/clubNavigation": [
		66162,
		9,
		66162
	],
	"./sport-hub-club/my/clubNavigation.js": [
		66162,
		9,
		66162
	],
	"./sport-hub-club/my/clubViewKeys": [
		92143,
		9,
		92143
	],
	"./sport-hub-club/my/clubViewKeys.js": [
		92143,
		9,
		92143
	],
	"./sport-hub-club/my/components/ClubCatalogActions": [
		80151,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		10838,
		95938
	],
	"./sport-hub-club/my/components/ClubCatalogActions.js": [
		80151,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		10838,
		95938
	],
	"./sport-hub-club/my/components/ClubCatalogCard": [
		73664,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		10838,
		76825
	],
	"./sport-hub-club/my/components/ClubCatalogCard.js": [
		73664,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		10838,
		76825
	],
	"./sport-hub-club/my/components/ClubCatalogMobileCard": [
		5205,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		5205
	],
	"./sport-hub-club/my/components/ClubCatalogMobileCard.js": [
		5205,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		5205
	],
	"./sport-hub-club/my/components/ClubCatalogNameCell": [
		18420,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		69866
	],
	"./sport-hub-club/my/components/ClubCatalogNameCell.js": [
		18420,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		69866
	],
	"./sport-hub-club/my/components/ClubCatalogStackItem": [
		39387,
		9,
		39387
	],
	"./sport-hub-club/my/components/ClubCatalogStackItem.js": [
		39387,
		9,
		39387
	],
	"./sport-hub-club/my/components/ClubCustomerPicker": [
		52424,
		9,
		58135,
		93288,
		97836,
		48634,
		27508,
		63780,
		93194
	],
	"./sport-hub-club/my/components/ClubCustomerPicker.js": [
		52424,
		9,
		58135,
		93288,
		97836,
		48634,
		27508,
		63780,
		93194
	],
	"./sport-hub-club/my/components/ClubCustomersSection": [
		18961,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		97994,
		77551,
		70776,
		74066,
		6779,
		23224,
		61842,
		95504
	],
	"./sport-hub-club/my/components/ClubCustomersSection.js": [
		18961,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		97994,
		77551,
		70776,
		74066,
		6779,
		23224,
		61842,
		95504
	],
	"./sport-hub-club/my/components/ClubEntryCard": [
		46402,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		46402
	],
	"./sport-hub-club/my/components/ClubEntryCard.js": [
		46402,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		46402
	],
	"./sport-hub-club/my/components/ClubMetaRow": [
		54252,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		97003
	],
	"./sport-hub-club/my/components/ClubMetaRow.js": [
		54252,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		97003
	],
	"./sport-hub-club/my/components/ClubMetricCardGrid": [
		3332,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		8048
	],
	"./sport-hub-club/my/components/ClubMetricCardGrid.js": [
		3332,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		8048
	],
	"./sport-hub-club/my/components/ClubSectionCollapse": [
		14322,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		23224,
		34395
	],
	"./sport-hub-club/my/components/ClubSectionCollapse.js": [
		14322,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		23224,
		34395
	],
	"./sport-hub-club/my/components/ClubSummaryItem": [
		1673,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		21212
	],
	"./sport-hub-club/my/components/ClubSummaryItem.js": [
		1673,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		21212
	],
	"./sport-hub-club/my/components/SportHubClubDetailShell": [
		93663,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		28492,
		70607
	],
	"./sport-hub-club/my/components/SportHubClubDetailShell.js": [
		93663,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		28492,
		70607
	],
	"./sport-hub-club/my/components/SportHubClubEmbeddedModals": [
		59133,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		40029,
		27508,
		63780,
		88084,
		10670,
		30154,
		10723,
		74066,
		87941,
		96642,
		32794,
		49764
	],
	"./sport-hub-club/my/components/SportHubClubEmbeddedModals.js": [
		59133,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		40029,
		27508,
		63780,
		88084,
		10670,
		30154,
		10723,
		74066,
		87941,
		96642,
		32794,
		49764
	],
	"./sport-hub-club/my/components/SportHubClubPackageDetail": [
		62855,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		70776,
		74066,
		6779,
		34148
	],
	"./sport-hub-club/my/components/SportHubClubPackageDetail.js": [
		62855,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		70776,
		74066,
		6779,
		34148
	],
	"./sport-hub-club/my/components/SportHubClubSectionToolbar": [
		38430,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		46851,
		20025,
		81408,
		54590,
		38430
	],
	"./sport-hub-club/my/components/SportHubClubSectionToolbar.js": [
		38430,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		46851,
		20025,
		81408,
		54590,
		38430
	],
	"./sport-hub-club/my/components/course-detail/CourseEnrollmentModal": [
		443,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		40029,
		27508,
		63780,
		10670,
		30154,
		10723,
		74066,
		87941,
		96642,
		12939
	],
	"./sport-hub-club/my/components/course-detail/CourseEnrollmentModal.js": [
		443,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		40029,
		27508,
		63780,
		10670,
		30154,
		10723,
		74066,
		87941,
		96642,
		12939
	],
	"./sport-hub-club/my/components/course-detail/CourseEnrollmentsSection": [
		87661,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		6779,
		17588
	],
	"./sport-hub-club/my/components/course-detail/CourseEnrollmentsSection.js": [
		87661,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		6779,
		17588
	],
	"./sport-hub-club/my/components/course-detail/CourseScheduleModal": [
		32162,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		40029,
		27508,
		63780,
		10670,
		30154,
		10723,
		74066,
		85596
	],
	"./sport-hub-club/my/components/course-detail/CourseScheduleModal.js": [
		32162,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		40029,
		27508,
		63780,
		10670,
		30154,
		10723,
		74066,
		85596
	],
	"./sport-hub-club/my/components/course-detail/CourseSchedulesSection": [
		36961,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		6779,
		92427
	],
	"./sport-hub-club/my/components/course-detail/CourseSchedulesSection.js": [
		36961,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		6779,
		92427
	],
	"./sport-hub-club/my/components/course-detail/CourseSessionsSection": [
		36591,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		6779,
		80777
	],
	"./sport-hub-club/my/components/course-detail/CourseSessionsSection.js": [
		36591,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		6779,
		80777
	],
	"./sport-hub-club/my/components/course-detail/constants": [
		97255,
		9,
		97255
	],
	"./sport-hub-club/my/components/course-detail/constants.js": [
		97255,
		9,
		97255
	],
	"./sport-hub-club/my/formatters": [
		52356,
		9,
		52356
	],
	"./sport-hub-club/my/formatters.js": [
		52356,
		9,
		52356
	],
	"./sport-hub-club/my/hooks/useClubCustomersViewModel": [
		61842,
		9,
		88084,
		61842,
		95349
	],
	"./sport-hub-club/my/hooks/useClubCustomersViewModel.js": [
		61842,
		9,
		88084,
		61842,
		95349
	],
	"./sport-hub-club/my/hooks/useCourseDetailController": [
		73276,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		88084,
		30154,
		88357
	],
	"./sport-hub-club/my/hooks/useCourseDetailController.js": [
		73276,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		88084,
		30154,
		88357
	],
	"./sport-hub-club/my/hooks/useSportHubClubEmbeddedController": [
		32794,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		88084,
		30154,
		32794,
		95660
	],
	"./sport-hub-club/my/hooks/useSportHubClubEmbeddedController.js": [
		32794,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		88084,
		30154,
		32794,
		95660
	],
	"./sport-hub-club/my/loyaltyHelpers": [
		43479,
		9,
		43479
	],
	"./sport-hub-club/my/loyaltyHelpers.js": [
		43479,
		9,
		43479
	],
	"./sport-hub-club/my/utils/clubCustomerGroups": [
		44197,
		9,
		88084,
		44197
	],
	"./sport-hub-club/my/utils/clubCustomerGroups.js": [
		44197,
		9,
		88084,
		44197
	],
	"./sport-hub-club/my/utils/clubCustomerPackages": [
		29546,
		9,
		29546
	],
	"./sport-hub-club/my/utils/clubCustomerPackages.js": [
		29546,
		9,
		29546
	],
	"./sport-hub-club/my/utils/courseOperationalStatus": [
		14056,
		9,
		14056
	],
	"./sport-hub-club/my/utils/courseOperationalStatus.js": [
		14056,
		9,
		14056
	],
	"./sport-hub-club/translation/en": [
		17960,
		3
	],
	"./sport-hub-club/translation/en.json": [
		17960,
		3
	],
	"./sport-hub-club/translation/it": [
		60016,
		3
	],
	"./sport-hub-club/translation/it.json": [
		60016,
		3
	],
	"./sport-hub-club/utils/courseResourceType": [
		6532,
		9,
		6532
	],
	"./sport-hub-club/utils/courseResourceType.js": [
		6532,
		9,
		6532
	],
	"./sport-hub-club/web": [
		73348,
		9,
		12696,
		61300,
		59632,
		23455,
		47857
	],
	"./sport-hub-club/web/": [
		73348,
		9,
		12696,
		61300,
		59632,
		23455,
		47857
	],
	"./sport-hub-club/web/PublicPage": [
		23455,
		9,
		12696,
		61300,
		59632,
		23455,
		84247
	],
	"./sport-hub-club/web/PublicPage.js": [
		23455,
		9,
		12696,
		61300,
		59632,
		23455,
		84247
	],
	"./sport-hub-club/web/index": [
		73348,
		9,
		12696,
		61300,
		59632,
		23455,
		47857
	],
	"./sport-hub-club/web/index.js": [
		73348,
		9,
		12696,
		61300,
		59632,
		23455,
		47857
	],
	"./sport-hub-club/web/publicPage.scss": [
		63961,
		9,
		63961
	],
	"./sport-hub-fantacalcetto/client/graphql/fantacalcetto": [
		65072,
		9,
		65072
	],
	"./sport-hub-fantacalcetto/client/graphql/fantacalcetto.js": [
		65072,
		9,
		65072
	],
	"./sport-hub-fantacalcetto/module": [
		48404,
		3
	],
	"./sport-hub-fantacalcetto/module.json": [
		48404,
		3
	],
	"./sport-hub-fantacalcetto/web/FantacalcettoFormationViewer": [
		36123,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		43806,
		8239
	],
	"./sport-hub-fantacalcetto/web/FantacalcettoFormationViewer.js": [
		36123,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		43806,
		8239
	],
	"./sport-hub-fantacalcetto/web/FantacalcettoResults": [
		58053,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		40029,
		75951,
		57933,
		58762,
		43806,
		12469
	],
	"./sport-hub-fantacalcetto/web/FantacalcettoResults.js": [
		58053,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		40029,
		75951,
		57933,
		58762,
		43806,
		12469
	],
	"./sport-hub-fantacalcetto/web/FantacalcettoTab": [
		86928,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		40029,
		75951,
		57933,
		58762,
		43806,
		47579
	],
	"./sport-hub-fantacalcetto/web/FantacalcettoTab.js": [
		86928,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		40029,
		75951,
		57933,
		58762,
		43806,
		47579
	],
	"./sport-hub-fantacalcetto/web/fantacalcetto.scss": [
		62980,
		9,
		62980
	],
	"./sport-hub-league/README.md": [
		67411,
		1,
		67411
	],
	"./sport-hub-league/client/graphql": [
		44027,
		9
	],
	"./sport-hub-league/client/graphql/": [
		44027,
		9
	],
	"./sport-hub-league/client/graphql/index": [
		44027,
		9
	],
	"./sport-hub-league/client/graphql/index.js": [
		44027,
		9
	],
	"./sport-hub-league/client/graphql/mutations": [
		28301,
		9
	],
	"./sport-hub-league/client/graphql/mutations.js": [
		28301,
		9
	],
	"./sport-hub-league/client/graphql/queries": [
		42926,
		9
	],
	"./sport-hub-league/client/graphql/queries.js": [
		42926,
		9
	],
	"./sport-hub-league/client/localState": [
		6678,
		9
	],
	"./sport-hub-league/client/localState.js": [
		6678,
		9
	],
	"./sport-hub-league/client/scss/NavsAsideExtends.scss": [
		51202,
		9
	],
	"./sport-hub-league/client/scss/index.scss": [
		56192,
		9
	],
	"./sport-hub-league/module": [
		45445,
		3
	],
	"./sport-hub-league/module.json": [
		45445,
		3
	],
	"./sport-hub-league/my/Calendar": [
		91930,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		24968,
		10723,
		77551,
		70776,
		87941,
		19119,
		37124,
		23224,
		13037,
		91930,
		5298
	],
	"./sport-hub-league/my/Calendar.js": [
		91930,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		24968,
		10723,
		77551,
		70776,
		87941,
		19119,
		37124,
		23224,
		13037,
		91930,
		5298
	],
	"./sport-hub-league/my/Dashboard": [
		64347,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		68408
	],
	"./sport-hub-league/my/Dashboard.js": [
		64347,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		68408
	],
	"./sport-hub-league/my/Emitters": [
		64690,
		9,
		64690
	],
	"./sport-hub-league/my/Emitters.js": [
		64690,
		9,
		64690
	],
	"./sport-hub-league/my/Match": [
		96079,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		28492,
		28669,
		78241
	],
	"./sport-hub-league/my/Match.js": [
		96079,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		28492,
		28669,
		78241
	],
	"./sport-hub-league/my/NavsAsideExtends": [
		50438,
		9
	],
	"./sport-hub-league/my/NavsAsideExtends.js": [
		50438,
		9
	],
	"./sport-hub-league/my/Settings": [
		57885,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		30154,
		10723,
		77551,
		16884,
		57885
	],
	"./sport-hub-league/my/Settings.js": [
		57885,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		30154,
		10723,
		77551,
		16884,
		57885
	],
	"./sport-hub-league/my/SportHubLeague": [
		36811,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		10723,
		77551,
		70776,
		87941,
		19119,
		37124,
		23224,
		13037,
		91930,
		47903
	],
	"./sport-hub-league/my/SportHubLeague.js": [
		36811,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		10723,
		77551,
		70776,
		87941,
		19119,
		37124,
		23224,
		13037,
		91930,
		47903
	],
	"./sport-hub-league/my/Standings": [
		3177,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		6779,
		21010,
		3177
	],
	"./sport-hub-league/my/Standings.js": [
		3177,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		6779,
		21010,
		3177
	],
	"./sport-hub-league/my/Teams": [
		916,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		10670,
		28492,
		24968,
		30154,
		10723,
		77551,
		47781,
		916
	],
	"./sport-hub-league/my/Teams.js": [
		916,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		10670,
		28492,
		24968,
		30154,
		10723,
		77551,
		47781,
		916
	],
	"./sport-hub-league/my/components/LeaguePageShell": [
		38818,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		21996
	],
	"./sport-hub-league/my/components/LeaguePageShell.js": [
		38818,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		21996
	],
	"./sport-hub-league/my/hooks/useShlLeagueSelection": [
		79175,
		9
	],
	"./sport-hub-league/my/hooks/useShlLeagueSelection.js": [
		79175,
		9
	],
	"./sport-hub-league/my/utils/bulkSchedulePlanner": [
		72203,
		9,
		72203
	],
	"./sport-hub-league/my/utils/bulkSchedulePlanner.js": [
		72203,
		9,
		72203
	],
	"./sport-hub-league/translation/en": [
		44063,
		3
	],
	"./sport-hub-league/translation/en.json": [
		44063,
		3
	],
	"./sport-hub-league/translation/it": [
		78580,
		3
	],
	"./sport-hub-league/translation/it.json": [
		78580,
		3
	],
	"./sport-hub-league/web": [
		50560,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		6779,
		75072,
		17959,
		26842,
		92352
	],
	"./sport-hub-league/web/": [
		50560,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		6779,
		75072,
		17959,
		26842,
		92352
	],
	"./sport-hub-league/web/Emitters": [
		22942,
		9,
		22942
	],
	"./sport-hub-league/web/Emitters.js": [
		22942,
		9,
		22942
	],
	"./sport-hub-league/web/LeaguePublic": [
		26842,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		6779,
		75072,
		17959,
		26842,
		30945
	],
	"./sport-hub-league/web/LeaguePublic.js": [
		26842,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		6779,
		75072,
		17959,
		26842,
		30945
	],
	"./sport-hub-league/web/MatchPublic": [
		72439,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		28669,
		72439
	],
	"./sport-hub-league/web/MatchPublic.js": [
		72439,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		28669,
		72439
	],
	"./sport-hub-league/web/index": [
		50560,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		6779,
		75072,
		17959,
		26842,
		92352
	],
	"./sport-hub-league/web/index.js": [
		50560,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		6779,
		75072,
		17959,
		26842,
		92352
	],
	"./sport-hub-league/web/publicLeague.scss": [
		22891,
		9,
		22891
	],
	"./sport-hub-pay/README.md": [
		58446,
		1,
		58446
	],
	"./sport-hub-pay/client/assets/images/thumbnail.jpg": [
		9963,
		1,
		9963
	],
	"./sport-hub-pay/client/graphql": [
		27006,
		9,
		27006
	],
	"./sport-hub-pay/client/graphql/": [
		27006,
		9,
		27006
	],
	"./sport-hub-pay/client/graphql/fragments": [
		39383,
		9,
		39383
	],
	"./sport-hub-pay/client/graphql/fragments.js": [
		39383,
		9,
		39383
	],
	"./sport-hub-pay/client/graphql/index": [
		27006,
		9,
		27006
	],
	"./sport-hub-pay/client/graphql/index.js": [
		27006,
		9,
		27006
	],
	"./sport-hub-pay/client/graphql/pay": [
		88850,
		9,
		88850
	],
	"./sport-hub-pay/client/graphql/pay.js": [
		88850,
		9,
		88850
	],
	"./sport-hub-pay/client/hooks": [
		8725,
		9,
		8725
	],
	"./sport-hub-pay/client/hooks/": [
		8725,
		9,
		8725
	],
	"./sport-hub-pay/client/hooks/index": [
		8725,
		9,
		8725
	],
	"./sport-hub-pay/client/hooks/index.js": [
		8725,
		9,
		8725
	],
	"./sport-hub-pay/client/scss/index.scss": [
		78283,
		9
	],
	"./sport-hub-pay/client/scss/publicPage.scss": [
		11735,
		9,
		90896,
		11735
	],
	"./sport-hub-pay/client/scss/sport-hub-movements.scss": [
		11165,
		9,
		11165
	],
	"./sport-hub-pay/client/utils/shPayData": [
		43476,
		9,
		43476
	],
	"./sport-hub-pay/client/utils/shPayData.js": [
		43476,
		9,
		43476
	],
	"./sport-hub-pay/module": [
		37237,
		3
	],
	"./sport-hub-pay/module.json": [
		37237,
		3
	],
	"./sport-hub-pay/my/SportHubPay": [
		89604,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		36899
	],
	"./sport-hub-pay/my/SportHubPay.js": [
		89604,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		36899
	],
	"./sport-hub-pay/my/components/MatchPaymentsAdvancedTab": [
		59938,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		24968,
		10723,
		58762,
		32908,
		97988,
		27790,
		49868
	],
	"./sport-hub-pay/my/components/MatchPaymentsAdvancedTab.js": [
		59938,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		24968,
		10723,
		58762,
		32908,
		97988,
		27790,
		49868
	],
	"./sport-hub-pay/my/components/MatchPaymentsCheckoutPanel": [
		52725,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		46851,
		20025,
		81408,
		54590,
		52725
	],
	"./sport-hub-pay/my/components/MatchPaymentsCheckoutPanel.js": [
		52725,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		46851,
		20025,
		81408,
		54590,
		52725
	],
	"./sport-hub-pay/my/components/MatchPaymentsSimpleTab": [
		83597,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		58762,
		74066,
		89364
	],
	"./sport-hub-pay/my/components/MatchPaymentsSimpleTab.js": [
		83597,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		58762,
		74066,
		89364
	],
	"./sport-hub-pay/my/components/movements/MovementGroupTagSelector": [
		9805,
		9,
		88084,
		54924,
		9805
	],
	"./sport-hub-pay/my/components/movements/MovementGroupTagSelector.js": [
		9805,
		9,
		88084,
		54924,
		9805
	],
	"./sport-hub-pay/my/components/movements/MovementTrendChart": [
		23812,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		88084,
		99217,
		88089
	],
	"./sport-hub-pay/my/components/movements/MovementTrendChart.js": [
		23812,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		88084,
		99217,
		88089
	],
	"./sport-hub-pay/my/components/movements/MovementsDashboardChart": [
		99217,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		88084,
		99217,
		45305
	],
	"./sport-hub-pay/my/components/movements/MovementsDashboardChart.antv": [
		77287,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		20025,
		81408,
		54590,
		27508,
		63780,
		88084,
		21850,
		29475,
		99217,
		12780,
		61199
	],
	"./sport-hub-pay/my/components/movements/MovementsDashboardChart.antv.js": [
		77287,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		20025,
		81408,
		54590,
		27508,
		63780,
		88084,
		21850,
		29475,
		99217,
		12780,
		61199
	],
	"./sport-hub-pay/my/components/movements/MovementsDashboardChart.js": [
		99217,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		88084,
		99217,
		45305
	],
	"./sport-hub-pay/my/components/movements/MovementsInfoDrawer": [
		87055,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		46851,
		20025,
		81408,
		40029,
		54590,
		88084,
		24968,
		11082
	],
	"./sport-hub-pay/my/components/movements/MovementsInfoDrawer.js": [
		87055,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		46851,
		20025,
		81408,
		40029,
		54590,
		88084,
		24968,
		11082
	],
	"./sport-hub-pay/my/components/movements/MovementsSection": [
		70647,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28669,
		24968,
		87941,
		96642,
		32770,
		95916,
		29475,
		99217,
		99170,
		70647,
		89116
	],
	"./sport-hub-pay/my/components/movements/MovementsSection.js": [
		70647,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28669,
		24968,
		87941,
		96642,
		32770,
		95916,
		29475,
		99217,
		99170,
		70647,
		89116
	],
	"./sport-hub-pay/my/components/movements/MovementsShopDetailsDrawer": [
		75826,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		40029,
		54590,
		88084,
		28669,
		24968,
		14782
	],
	"./sport-hub-pay/my/components/movements/MovementsShopDetailsDrawer.js": [
		75826,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		40029,
		54590,
		88084,
		28669,
		24968,
		14782
	],
	"./sport-hub-pay/my/components/movements/MovimentDrawer": [
		91053,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		40029,
		54590,
		27508,
		63780,
		88084,
		10670,
		24968,
		30154,
		10723,
		70776,
		87941,
		96642,
		91053,
		59057
	],
	"./sport-hub-pay/my/components/movements/MovimentDrawer.js": [
		91053,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		40029,
		54590,
		27508,
		63780,
		88084,
		10670,
		24968,
		30154,
		10723,
		70776,
		87941,
		96642,
		91053,
		59057
	],
	"./sport-hub-pay/my/hooks/match-manager/useMatchClubPaymentResources": [
		86180,
		9,
		86180
	],
	"./sport-hub-pay/my/hooks/match-manager/useMatchClubPaymentResources.js": [
		86180,
		9,
		86180
	],
	"./sport-hub-pay/my/hooks/match-manager/useMatchPaymentsCheckout": [
		27790,
		9,
		27790,
		17555
	],
	"./sport-hub-pay/my/hooks/match-manager/useMatchPaymentsCheckout.js": [
		27790,
		9,
		27790,
		17555
	],
	"./sport-hub-pay/my/hooks/match-manager/useMatchPaymentsController": [
		55317,
		9,
		55317
	],
	"./sport-hub-pay/my/hooks/match-manager/useMatchPaymentsController.js": [
		55317,
		9,
		55317
	],
	"./sport-hub-pay/my/hooks/match-manager/useMatchShopProducts": [
		57989,
		9,
		57989
	],
	"./sport-hub-pay/my/hooks/match-manager/useMatchShopProducts.js": [
		57989,
		9,
		57989
	],
	"./sport-hub-pay/my/hooks/movements/useMovementsFilters": [
		99170,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		54590,
		27508,
		63780,
		88084,
		10670,
		29475,
		99170,
		65036
	],
	"./sport-hub-pay/my/hooks/movements/useMovementsFilters.js": [
		99170,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		54590,
		27508,
		63780,
		88084,
		10670,
		29475,
		99170,
		65036
	],
	"./sport-hub-pay/my/hooks/movements/useShopMovementDetails": [
		95677,
		9,
		88084,
		95677
	],
	"./sport-hub-pay/my/hooks/movements/useShopMovementDetails.js": [
		95677,
		9,
		88084,
		95677
	],
	"./sport-hub-pay/my/hooks/movements/useSportHubMovementsManager": [
		5362,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		40029,
		88084,
		30154,
		74066,
		5362,
		42857
	],
	"./sport-hub-pay/my/hooks/movements/useSportHubMovementsManager.js": [
		5362,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		40029,
		88084,
		30154,
		74066,
		5362,
		42857
	],
	"./sport-hub-pay/my/hooks/movements/useSportHubMovementsSectionController": [
		4629,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		40029,
		88084,
		30154,
		74066,
		29475,
		5362,
		24938
	],
	"./sport-hub-pay/my/hooks/movements/useSportHubMovementsSectionController.js": [
		4629,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		40029,
		88084,
		30154,
		74066,
		29475,
		5362,
		24938
	],
	"./sport-hub-pay/my/payment": [
		55538,
		9,
		55538
	],
	"./sport-hub-pay/my/payment/": [
		55538,
		9,
		55538
	],
	"./sport-hub-pay/my/payment/constants": [
		20417,
		9,
		20417
	],
	"./sport-hub-pay/my/payment/constants.js": [
		20417,
		9,
		20417
	],
	"./sport-hub-pay/my/payment/index": [
		55538,
		9,
		55538
	],
	"./sport-hub-pay/my/payment/index.js": [
		55538,
		9,
		55538
	],
	"./sport-hub-pay/my/payment/normalizers": [
		8687,
		9,
		8687
	],
	"./sport-hub-pay/my/payment/normalizers.js": [
		8687,
		9,
		8687
	],
	"./sport-hub-pay/my/payment/selectors": [
		62181,
		9,
		62181
	],
	"./sport-hub-pay/my/payment/selectors.js": [
		62181,
		9,
		62181
	],
	"./sport-hub-pay/my/payment/totals": [
		27932,
		9,
		27932
	],
	"./sport-hub-pay/my/payment/totals.js": [
		27932,
		9,
		27932
	],
	"./sport-hub-pay/my/utils/matchPaymentResources": [
		39713,
		9,
		39713
	],
	"./sport-hub-pay/my/utils/matchPaymentResources.js": [
		39713,
		9,
		39713
	],
	"./sport-hub-pay/my/utils/movements/movementGroups": [
		55971,
		9,
		55971
	],
	"./sport-hub-pay/my/utils/movements/movementGroups.js": [
		55971,
		9,
		55971
	],
	"./sport-hub-pay/my/utils/movements/movementHelpers": [
		85034,
		9,
		88084,
		85034
	],
	"./sport-hub-pay/my/utils/movements/movementHelpers.js": [
		85034,
		9,
		88084,
		85034
	],
	"./sport-hub-pay/my/utils/movements/movementOverviewSelectors": [
		29475,
		9,
		88084,
		29475,
		75106
	],
	"./sport-hub-pay/my/utils/movements/movementOverviewSelectors.js": [
		29475,
		9,
		88084,
		29475,
		75106
	],
	"./sport-hub-pay/translation/en": [
		55964,
		3
	],
	"./sport-hub-pay/translation/en.json": [
		55964,
		3
	],
	"./sport-hub-pay/translation/it": [
		31498,
		3
	],
	"./sport-hub-pay/translation/it.json": [
		31498,
		3
	],
	"./sport-hub-pay/web": [
		77454,
		9,
		12696,
		61300,
		90896,
		3608,
		73348
	],
	"./sport-hub-pay/web/": [
		77454,
		9,
		12696,
		61300,
		90896,
		3608,
		73348
	],
	"./sport-hub-pay/web/PublicPage": [
		3608,
		9,
		12696,
		61300,
		90896,
		3608,
		63344
	],
	"./sport-hub-pay/web/PublicPage.js": [
		3608,
		9,
		12696,
		61300,
		90896,
		3608,
		63344
	],
	"./sport-hub-pay/web/index": [
		77454,
		9,
		12696,
		61300,
		90896,
		3608,
		73348
	],
	"./sport-hub-pay/web/index.js": [
		77454,
		9,
		12696,
		61300,
		90896,
		3608,
		73348
	],
	"./sport-hub-pay/web/publicPage.scss": [
		50589,
		9,
		50589
	],
	"./sport-hub-pro/README.md": [
		7151,
		1,
		7151
	],
	"./sport-hub-pro/client/assets/images/thumbnail.jpg": [
		63723,
		1,
		63723
	],
	"./sport-hub-pro/client/scss/index.scss": [
		35960,
		9
	],
	"./sport-hub-pro/client/scss/publicPage.scss": [
		14174,
		9,
		75510,
		14174
	],
	"./sport-hub-pro/module": [
		18793,
		3
	],
	"./sport-hub-pro/module.json": [
		18793,
		3
	],
	"./sport-hub-pro/my/SportHubPro": [
		61035,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		65356
	],
	"./sport-hub-pro/my/SportHubPro.js": [
		61035,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		65356
	],
	"./sport-hub-pro/translation/en": [
		56458,
		3
	],
	"./sport-hub-pro/translation/en.json": [
		56458,
		3
	],
	"./sport-hub-pro/translation/it": [
		12816,
		3
	],
	"./sport-hub-pro/translation/it.json": [
		12816,
		3
	],
	"./sport-hub-pro/web": [
		79643,
		9,
		12696,
		61300,
		75510,
		16294,
		73513
	],
	"./sport-hub-pro/web/": [
		79643,
		9,
		12696,
		61300,
		75510,
		16294,
		73513
	],
	"./sport-hub-pro/web/PublicPage": [
		16294,
		9,
		12696,
		61300,
		75510,
		16294,
		99386
	],
	"./sport-hub-pro/web/PublicPage.js": [
		16294,
		9,
		12696,
		61300,
		75510,
		16294,
		99386
	],
	"./sport-hub-pro/web/index": [
		79643,
		9,
		12696,
		61300,
		75510,
		16294,
		73513
	],
	"./sport-hub-pro/web/index.js": [
		79643,
		9,
		12696,
		61300,
		75510,
		16294,
		73513
	],
	"./sport-hub-pro/web/publicPage.scss": [
		17265,
		9,
		17265
	],
	"./sport-hub-web/README.md": [
		28373,
		1,
		28373
	],
	"./sport-hub-web/client/assets/images/thumbnail.jpg": [
		69710,
		1,
		69710
	],
	"./sport-hub-web/client/scss/index.scss": [
		3993,
		9
	],
	"./sport-hub-web/client/scss/publicPage.scss": [
		28605,
		9,
		44912,
		28605
	],
	"./sport-hub-web/module": [
		93871,
		3
	],
	"./sport-hub-web/module.json": [
		93871,
		3
	],
	"./sport-hub-web/my/SportHubWeb": [
		34698,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		16073
	],
	"./sport-hub-web/my/SportHubWeb.js": [
		34698,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		46851,
		35348,
		28492,
		16073
	],
	"./sport-hub-web/translation/en": [
		24692,
		3
	],
	"./sport-hub-web/translation/en.json": [
		24692,
		3
	],
	"./sport-hub-web/translation/it": [
		99418,
		3
	],
	"./sport-hub-web/translation/it.json": [
		99418,
		3
	],
	"./sport-hub-web/web": [
		34834,
		9,
		12696,
		61300,
		44912,
		37948,
		73078
	],
	"./sport-hub-web/web/": [
		34834,
		9,
		12696,
		61300,
		44912,
		37948,
		73078
	],
	"./sport-hub-web/web/PublicPage": [
		37948,
		9,
		12696,
		61300,
		44912,
		37948,
		32441
	],
	"./sport-hub-web/web/PublicPage.js": [
		37948,
		9,
		12696,
		61300,
		44912,
		37948,
		32441
	],
	"./sport-hub-web/web/index": [
		34834,
		9,
		12696,
		61300,
		44912,
		37948,
		73078
	],
	"./sport-hub-web/web/index.js": [
		34834,
		9,
		12696,
		61300,
		44912,
		37948,
		73078
	],
	"./sport-hub-web/web/publicPage.scss": [
		95101,
		9,
		95101
	],
	"./sport-hub/README.md": [
		93620,
		1,
		66249
	],
	"./sport-hub/client/assets/10_logo_sport_hub.png": [
		58487,
		1,
		58487
	],
	"./sport-hub/client/assets/images/qr_double.svg": [
		27234,
		1,
		27234
	],
	"./sport-hub/client/assets/images/qr_multiple.svg": [
		77832,
		1,
		77832
	],
	"./sport-hub/client/assets/images/qr_single.svg": [
		43687,
		1,
		43687
	],
	"./sport-hub/client/assets/images/thumbnail.jpg": [
		89617,
		1,
		89617
	],
	"./sport-hub/client/assets/logos-extracted/sporthub_logo_01.png": [
		76132,
		1,
		76132
	],
	"./sport-hub/client/assets/logos-extracted/sporthub_logo_02.png": [
		58476,
		1,
		58476
	],
	"./sport-hub/client/assets/logos-extracted/sporthub_logo_03.png": [
		14906,
		1,
		14906
	],
	"./sport-hub/client/assets/logos-extracted/sporthub_logo_04.png": [
		81860,
		1,
		81860
	],
	"./sport-hub/client/assets/logos-extracted/sporthub_logo_05.png": [
		61180,
		1,
		61180
	],
	"./sport-hub/client/assets/logos-extracted/sporthub_logo_06.png": [
		89050,
		1,
		89050
	],
	"./sport-hub/client/assets/logos-extracted/sporthub_logo_07.png": [
		52523,
		1,
		52523
	],
	"./sport-hub/client/assets/logos-extracted/sporthub_logo_08.png": [
		8923,
		1,
		8923
	],
	"./sport-hub/client/assets/logos-extracted/sporthub_logo_09.png": [
		40226,
		1,
		40226
	],
	"./sport-hub/client/assets/logos-extracted/sporthub_logo_10.png": [
		12275,
		1,
		12275
	],
	"./sport-hub/client/assets/logos-extracted/sporthub_logo_11.png": [
		98745,
		1,
		98745
	],
	"./sport-hub/client/assets/logos-extracted/sporthub_logo_12.png": [
		82278,
		1,
		82278
	],
	"./sport-hub/client/graphql": [
		34777,
		9
	],
	"./sport-hub/client/graphql/": [
		34777,
		9
	],
	"./sport-hub/client/graphql/assistant": [
		27565,
		9
	],
	"./sport-hub/client/graphql/assistant.js": [
		27565,
		9
	],
	"./sport-hub/client/graphql/availabilityRequests": [
		43413,
		9
	],
	"./sport-hub/client/graphql/availabilityRequests.js": [
		43413,
		9
	],
	"./sport-hub/client/graphql/club": [
		17555,
		9,
		13201
	],
	"./sport-hub/client/graphql/club.js": [
		17555,
		9,
		13201
	],
	"./sport-hub/client/graphql/dashboard": [
		38393,
		9
	],
	"./sport-hub/client/graphql/dashboard.js": [
		38393,
		9
	],
	"./sport-hub/client/graphql/fields": [
		90421,
		9
	],
	"./sport-hub/client/graphql/fields.js": [
		90421,
		9
	],
	"./sport-hub/client/graphql/fragments": [
		29891,
		9
	],
	"./sport-hub/client/graphql/fragments.js": [
		29891,
		9
	],
	"./sport-hub/client/graphql/index": [
		34777,
		9
	],
	"./sport-hub/client/graphql/index.js": [
		34777,
		9
	],
	"./sport-hub/client/graphql/matches": [
		42606,
		9
	],
	"./sport-hub/client/graphql/matches.js": [
		42606,
		9
	],
	"./sport-hub/client/graphql/notifications": [
		26731,
		9
	],
	"./sport-hub/client/graphql/notifications.js": [
		26731,
		9
	],
	"./sport-hub/client/graphql/players": [
		381,
		9
	],
	"./sport-hub/client/graphql/players.js": [
		381,
		9
	],
	"./sport-hub/client/graphql/public": [
		73728,
		9
	],
	"./sport-hub/client/graphql/public.js": [
		73728,
		9
	],
	"./sport-hub/client/graphql/reservations": [
		42299,
		9
	],
	"./sport-hub/client/graphql/reservations.js": [
		42299,
		9
	],
	"./sport-hub/client/graphql/settings": [
		31174,
		9
	],
	"./sport-hub/client/graphql/settings.js": [
		31174,
		9
	],
	"./sport-hub/client/graphql/slots": [
		26150,
		9
	],
	"./sport-hub/client/graphql/slots.js": [
		26150,
		9
	],
	"./sport-hub/client/graphql/structures": [
		76420,
		9
	],
	"./sport-hub/client/graphql/structures.js": [
		76420,
		9
	],
	"./sport-hub/client/hooks": [
		58117,
		9,
		58117
	],
	"./sport-hub/client/hooks/": [
		58117,
		9,
		58117
	],
	"./sport-hub/client/hooks/index": [
		58117,
		9,
		58117
	],
	"./sport-hub/client/hooks/index.js": [
		58117,
		9,
		58117
	],
	"./sport-hub/client/hooks/matchCacheHelpers": [
		36431,
		9,
		36431
	],
	"./sport-hub/client/hooks/matchCacheHelpers.js": [
		36431,
		9,
		36431
	],
	"./sport-hub/client/hooks/usePlayerLevelOptions": [
		93823,
		9,
		93823
	],
	"./sport-hub/client/hooks/usePlayerLevelOptions.js": [
		93823,
		9,
		93823
	],
	"./sport-hub/client/hooks/useSportTypeOptions": [
		90412,
		9,
		90412
	],
	"./sport-hub/client/hooks/useSportTypeOptions.js": [
		90412,
		9,
		90412
	],
	"./sport-hub/client/localState": [
		73715,
		9,
		73715
	],
	"./sport-hub/client/localState.js": [
		73715,
		9,
		73715
	],
	"./sport-hub/client/scss/NavsAsideExtends.scss": [
		47851,
		9
	],
	"./sport-hub/client/scss/QRCodePage.scss": [
		79621,
		9,
		79621
	],
	"./sport-hub/client/scss/clienti.scss": [
		48659,
		9,
		48659
	],
	"./sport-hub/client/scss/dashboard.scss": [
		44719,
		9,
		44719
	],
	"./sport-hub/client/scss/field.scss": [
		11533,
		9,
		11533
	],
	"./sport-hub/client/scss/index.scss": [
		16980,
		9
	],
	"./sport-hub/client/scss/match.scss": [
		26624,
		9,
		26624
	],
	"./sport-hub/client/scss/overview.scss": [
		33337,
		9,
		33337
	],
	"./sport-hub/client/scss/overview/_00-shared.scss": [
		27306,
		9,
		27306
	],
	"./sport-hub/client/scss/overview/_10-day.scss": [
		51738,
		9,
		51738
	],
	"./sport-hub/client/scss/overview/_20-calendar-modes.scss": [
		24410,
		9,
		24410
	],
	"./sport-hub/client/scss/overview/_30-movements.scss": [
		46372,
		9,
		46372
	],
	"./sport-hub/client/scss/overview/_40-notifications.scss": [
		6916,
		9,
		6916
	],
	"./sport-hub/client/scss/partite.scss": [
		41921,
		9,
		41921
	],
	"./sport-hub/client/scss/publicPage.scss": [
		4070,
		9,
		4070
	],
	"./sport-hub/client/scss/result-editors.scss": [
		80845,
		9,
		80845
	],
	"./sport-hub/client/scss/settings.scss": [
		30997,
		9,
		30997
	],
	"./sport-hub/client/scss/shop.scss": [
		5059,
		9,
		5059
	],
	"./sport-hub/client/scss/sport-hub-overview.scss": [
		30939,
		9,
		30939
	],
	"./sport-hub/client/scss/utilities.scss": [
		30582,
		9,
		30582
	],
	"./sport-hub/client/scss/variables.scss": [
		86125,
		9,
		86125
	],
	"./sport-hub/client/typePolicies": [
		61405,
		9,
		61405
	],
	"./sport-hub/client/typePolicies.js": [
		61405,
		9,
		61405
	],
	"./sport-hub/client/utils/constants": [
		29630,
		9,
		29630
	],
	"./sport-hub/client/utils/constants.js": [
		29630,
		9,
		29630
	],
	"./sport-hub/client/utils/formatters": [
		84599,
		9,
		84599
	],
	"./sport-hub/client/utils/formatters.js": [
		84599,
		9,
		84599
	],
	"./sport-hub/client/utils/reservationsCache": [
		51602,
		9,
		88084,
		51602
	],
	"./sport-hub/client/utils/reservationsCache.js": [
		51602,
		9,
		88084,
		51602
	],
	"./sport-hub/client/utils/saveFlow": [
		12309,
		9,
		12309
	],
	"./sport-hub/client/utils/saveFlow.js": [
		12309,
		9,
		12309
	],
	"./sport-hub/client/utils/shData": [
		71276,
		9
	],
	"./sport-hub/client/utils/shData.js": [
		71276,
		9
	],
	"./sport-hub/client/utils/slotUtils": [
		77039,
		9,
		88084,
		77039
	],
	"./sport-hub/client/utils/slotUtils.js": [
		77039,
		9,
		88084,
		77039
	],
	"./sport-hub/client/utils/sportContext": [
		72030,
		9,
		72030
	],
	"./sport-hub/client/utils/sportContext.js": [
		72030,
		9,
		72030
	],
	"./sport-hub/components/DrawerActionFooter": [
		78345,
		9,
		4016,
		74556,
		32789
	],
	"./sport-hub/components/DrawerActionFooter.js": [
		78345,
		9,
		4016,
		74556,
		32789
	],
	"./sport-hub/components/DrawerShell": [
		74907,
		9,
		58135,
		40029,
		24968,
		3316
	],
	"./sport-hub/components/DrawerShell.js": [
		74907,
		9,
		58135,
		40029,
		24968,
		3316
	],
	"./sport-hub/components/PlayerAvatar": [
		21812,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		46851,
		58762,
		3059
	],
	"./sport-hub/components/PlayerAvatar.js": [
		21812,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		46851,
		58762,
		3059
	],
	"./sport-hub/components/PlayerLineupImportButton": [
		7253,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28669,
		24968,
		55627
	],
	"./sport-hub/components/PlayerLineupImportButton.js": [
		7253,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28669,
		24968,
		55627
	],
	"./sport-hub/components/QRCodeRenderer": [
		56213,
		9,
		19454,
		56213
	],
	"./sport-hub/components/QRCodeRenderer.js": [
		56213,
		9,
		19454,
		56213
	],
	"./sport-hub/components/ResponsiveCards": [
		42426,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		92323,
		30866
	],
	"./sport-hub/components/ResponsiveCards.js": [
		42426,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		92323,
		30866
	],
	"./sport-hub/components/SettingsFormDrawer": [
		11203,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		40029,
		24968,
		30154,
		35291
	],
	"./sport-hub/components/SettingsFormDrawer.js": [
		11203,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		40029,
		24968,
		30154,
		35291
	],
	"./sport-hub/components/SettingsSectionCard": [
		55031,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		55031
	],
	"./sport-hub/components/SettingsSectionCard.js": [
		55031,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		55031
	],
	"./sport-hub/components/StructureMediaGallery": [
		2474,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		92323,
		17161
	],
	"./sport-hub/components/StructureMediaGallery.js": [
		2474,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		92323,
		17161
	],
	"./sport-hub/components/StructureMediaManager": [
		16747,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		19119,
		92323,
		61079,
		78957,
		16747,
		52782
	],
	"./sport-hub/components/StructureMediaManager.js": [
		16747,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		19119,
		92323,
		61079,
		78957,
		16747,
		52782
	],
	"./sport-hub/components/match/MatchFormationViewer": [
		75935,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		43806,
		22442
	],
	"./sport-hub/components/match/MatchFormationViewer.js": [
		75935,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		43806,
		22442
	],
	"./sport-hub/components/match/MatchResultEditor": [
		65983,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		43806,
		53887
	],
	"./sport-hub/components/match/MatchResultEditor.js": [
		65983,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		43806,
		53887
	],
	"./sport-hub/components/match/MatchResultNormalizer": [
		35969,
		9,
		35969
	],
	"./sport-hub/components/match/MatchResultNormalizer.js": [
		35969,
		9,
		35969
	],
	"./sport-hub/components/match/MatchResultViewer": [
		26872,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		43806,
		18896
	],
	"./sport-hub/components/match/MatchResultViewer.js": [
		26872,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		43806,
		18896
	],
	"./sport-hub/components/match/sportRegistry": [
		43806,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		43806,
		1598
	],
	"./sport-hub/components/match/sportRegistry.js": [
		43806,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		43806,
		1598
	],
	"./sport-hub/components/match/sports/padel/PadelFormationViewer": [
		43390,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		46851,
		58762,
		179
	],
	"./sport-hub/components/match/sports/padel/PadelFormationViewer.js": [
		43390,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		46851,
		58762,
		179
	],
	"./sport-hub/components/match/sports/padel/PadelResultEditor": [
		83934,
		9,
		4016,
		74556,
		88934
	],
	"./sport-hub/components/match/sports/padel/PadelResultEditor.js": [
		83934,
		9,
		4016,
		74556,
		88934
	],
	"./sport-hub/components/match/sports/padel/PadelResultViewer": [
		64528,
		9,
		64528
	],
	"./sport-hub/components/match/sports/padel/PadelResultViewer.js": [
		64528,
		9,
		64528
	],
	"./sport-hub/components/match/sports/padel/PadelTeamView": [
		25173,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		46851,
		58762,
		14491
	],
	"./sport-hub/components/match/sports/padel/PadelTeamView.js": [
		25173,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		46851,
		58762,
		14491
	],
	"./sport-hub/components/match/sports/soccer/SoccerFormationViewer": [
		57951,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		46851,
		58762,
		48403
	],
	"./sport-hub/components/match/sports/soccer/SoccerFormationViewer.js": [
		57951,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		46851,
		58762,
		48403
	],
	"./sport-hub/components/match/sports/soccer/SoccerResultEditor": [
		47939,
		9,
		4016,
		74556,
		88663
	],
	"./sport-hub/components/match/sports/soccer/SoccerResultEditor.js": [
		47939,
		9,
		4016,
		74556,
		88663
	],
	"./sport-hub/components/match/sports/soccer/SoccerResultViewer": [
		28702,
		9,
		28702
	],
	"./sport-hub/components/match/sports/soccer/SoccerResultViewer.js": [
		28702,
		9,
		28702
	],
	"./sport-hub/components/match/sports/soccer/SoccerTeamView": [
		63174,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		46851,
		58762,
		52557
	],
	"./sport-hub/components/match/sports/soccer/SoccerTeamView.js": [
		63174,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		46851,
		58762,
		52557
	],
	"./sport-hub/components/match/sports/soccer/resultUtils": [
		20182,
		9,
		20182
	],
	"./sport-hub/components/match/sports/soccer/resultUtils.js": [
		20182,
		9,
		20182
	],
	"./sport-hub/config/notifications": [
		84186,
		9,
		84186
	],
	"./sport-hub/config/notifications.js": [
		84186,
		9,
		84186
	],
	"./sport-hub/config/resourceTypes": [
		65132,
		9,
		65132
	],
	"./sport-hub/config/resourceTypes.js": [
		65132,
		9,
		65132
	],
	"./sport-hub/config/sportTypes": [
		56131,
		9,
		56131
	],
	"./sport-hub/config/sportTypes.js": [
		56131,
		9,
		56131
	],
	"./sport-hub/docs/advanced-payments.md": [
		91743,
		1,
		91743
	],
	"./sport-hub/docs/reservation-and-course-compatibility.md": [
		33811,
		1,
		33811
	],
	"./sport-hub/module": [
		95548,
		3
	],
	"./sport-hub/module.json": [
		95548,
		3
	],
	"./sport-hub/my/AvailabilityRequests": [
		39468,
		9,
		39468
	],
	"./sport-hub/my/AvailabilityRequests.js": [
		39468,
		9,
		39468
	],
	"./sport-hub/my/Clienti": [
		44099,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		58762,
		77551,
		70776,
		6779,
		32908,
		22446,
		58117,
		44099
	],
	"./sport-hub/my/Clienti.js": [
		44099,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		58762,
		77551,
		70776,
		6779,
		32908,
		22446,
		58117,
		44099
	],
	"./sport-hub/my/Dashboard": [
		495,
		9,
		495
	],
	"./sport-hub/my/Dashboard.js": [
		495,
		9,
		495
	],
	"./sport-hub/my/Emitters": [
		74608,
		9,
		74608
	],
	"./sport-hub/my/Emitters.js": [
		74608,
		9,
		74608
	],
	"./sport-hub/my/LessonManager": [
		94064,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		10723,
		58762,
		74066,
		32908,
		97988,
		58117,
		27790,
		35772,
		49408
	],
	"./sport-hub/my/LessonManager.js": [
		94064,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		10723,
		58762,
		74066,
		32908,
		97988,
		58117,
		27790,
		35772,
		49408
	],
	"./sport-hub/my/MatchManager": [
		35772,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		10723,
		58762,
		74066,
		32908,
		97988,
		58117,
		27790,
		35772,
		6731
	],
	"./sport-hub/my/MatchManager.js": [
		35772,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		10723,
		58762,
		74066,
		32908,
		97988,
		58117,
		27790,
		35772,
		6731
	],
	"./sport-hub/my/NavsAsideExtends": [
		80484,
		9
	],
	"./sport-hub/my/NavsAsideExtends.js": [
		80484,
		9
	],
	"./sport-hub/my/Partite": [
		20717,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		97994,
		77551,
		70776,
		87941,
		6779,
		96642,
		43415,
		65339,
		20717,
		68527
	],
	"./sport-hub/my/Partite.js": [
		20717,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		97994,
		77551,
		70776,
		87941,
		6779,
		96642,
		43415,
		65339,
		20717,
		68527
	],
	"./sport-hub/my/PartyManager": [
		72493,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		10723,
		22370,
		21121,
		81400,
		58117,
		85212,
		60140
	],
	"./sport-hub/my/PartyManager.js": [
		72493,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		10723,
		22370,
		21121,
		81400,
		58117,
		85212,
		60140
	],
	"./sport-hub/my/Player": [
		9555,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		87941,
		96642,
		32908,
		58117,
		55275,
		9555,
		78848
	],
	"./sport-hub/my/Player.js": [
		9555,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		87941,
		96642,
		32908,
		58117,
		55275,
		9555,
		78848
	],
	"./sport-hub/my/Prenotazioni": [
		47553,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		97994,
		77551,
		70776,
		87941,
		6779,
		96642,
		43415,
		65339,
		20717,
		47196
	],
	"./sport-hub/my/Prenotazioni.js": [
		47553,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		97994,
		77551,
		70776,
		87941,
		6779,
		96642,
		43415,
		65339,
		20717,
		47196
	],
	"./sport-hub/my/QRCodePage": [
		74829,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		40029,
		27508,
		63780,
		75951,
		57933,
		28492,
		19454,
		51802,
		24291
	],
	"./sport-hub/my/QRCodePage.js": [
		74829,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		40029,
		27508,
		63780,
		75951,
		57933,
		28492,
		19454,
		51802,
		24291
	],
	"./sport-hub/my/ReunionManager": [
		3585,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		10723,
		22370,
		21121,
		81400,
		58117,
		85212,
		83798
	],
	"./sport-hub/my/ReunionManager.js": [
		3585,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		10723,
		22370,
		21121,
		81400,
		58117,
		85212,
		83798
	],
	"./sport-hub/my/Settings": [
		99308,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		70776,
		6779,
		19119,
		92323,
		61079,
		4583,
		58117,
		99308
	],
	"./sport-hub/my/Settings.js": [
		99308,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		70776,
		6779,
		19119,
		92323,
		61079,
		4583,
		58117,
		99308
	],
	"./sport-hub/my/Shop": [
		97079,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		30154,
		10723,
		92323,
		70909,
		12623
	],
	"./sport-hub/my/Shop.js": [
		97079,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		30154,
		10723,
		92323,
		70909,
		12623
	],
	"./sport-hub/my/SportHub": [
		37766,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		70776,
		74066,
		87941,
		6779,
		92323,
		80042,
		68610,
		47097,
		58117,
		99004,
		85212,
		11013,
		75394,
		12082,
		52639,
		67465
	],
	"./sport-hub/my/SportHub.js": [
		37766,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		70776,
		74066,
		87941,
		6779,
		92323,
		80042,
		68610,
		47097,
		58117,
		99004,
		85212,
		11013,
		75394,
		12082,
		52639,
		67465
	],
	"./sport-hub/my/Staff": [
		4382,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		24968,
		30154,
		10723,
		74066,
		92323,
		19454,
		37218,
		58117,
		13263,
		4382
	],
	"./sport-hub/my/Staff.js": [
		4382,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		24968,
		30154,
		10723,
		74066,
		92323,
		19454,
		37218,
		58117,
		13263,
		4382
	],
	"./sport-hub/my/TournamentManager": [
		73077,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		10723,
		58762,
		74066,
		32908,
		97988,
		58117,
		27790,
		35772,
		93970
	],
	"./sport-hub/my/TournamentManager.js": [
		73077,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		10723,
		58762,
		74066,
		32908,
		97988,
		58117,
		27790,
		35772,
		93970
	],
	"./sport-hub/my/components/AvailabilityRequestsPanel": [
		71663,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		74066,
		6779,
		89249,
		91675
	],
	"./sport-hub/my/components/AvailabilityRequestsPanel.js": [
		71663,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		74066,
		6779,
		89249,
		91675
	],
	"./sport-hub/my/components/AvailableSlotCard": [
		22112,
		9,
		58135,
		93288,
		97836,
		48634,
		46851,
		35348,
		40029,
		75951,
		57933,
		88084,
		27105
	],
	"./sport-hub/my/components/AvailableSlotCard.js": [
		22112,
		9,
		58135,
		93288,
		97836,
		48634,
		46851,
		35348,
		40029,
		75951,
		57933,
		88084,
		27105
	],
	"./sport-hub/my/components/CreatePlayerDrawer": [
		49479,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		40029,
		54590,
		27508,
		63780,
		10670,
		24968,
		30154,
		32908,
		79584
	],
	"./sport-hub/my/components/CreatePlayerDrawer.js": [
		49479,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		40029,
		54590,
		27508,
		63780,
		10670,
		24968,
		30154,
		32908,
		79584
	],
	"./sport-hub/my/components/FieldCalendar": [
		18657,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		14451,
		46851,
		40029,
		27508,
		63780,
		88084,
		28669,
		24968,
		97994,
		70776,
		87941,
		75072,
		50993,
		63482,
		99004,
		45141
	],
	"./sport-hub/my/components/FieldCalendar/": [
		18657,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		14451,
		46851,
		40029,
		27508,
		63780,
		88084,
		28669,
		24968,
		97994,
		70776,
		87941,
		75072,
		50993,
		63482,
		99004,
		45141
	],
	"./sport-hub/my/components/FieldCalendar/DateNavigator": [
		99004,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		14451,
		46851,
		40029,
		27508,
		63780,
		88084,
		28669,
		24968,
		97994,
		75072,
		50993,
		99004,
		71888
	],
	"./sport-hub/my/components/FieldCalendar/DateNavigator.js": [
		99004,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		14451,
		46851,
		40029,
		27508,
		63780,
		88084,
		28669,
		24968,
		97994,
		75072,
		50993,
		99004,
		71888
	],
	"./sport-hub/my/components/FieldCalendar/ModeSwitch": [
		22176,
		9,
		46851,
		22176
	],
	"./sport-hub/my/components/FieldCalendar/ModeSwitch.js": [
		22176,
		9,
		46851,
		22176
	],
	"./sport-hub/my/components/FieldCalendar/MonthView": [
		63435,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		14451,
		46851,
		40029,
		27508,
		63780,
		88084,
		28669,
		24968,
		97994,
		70776,
		87941,
		75072,
		50993,
		63482,
		99004,
		70727
	],
	"./sport-hub/my/components/FieldCalendar/MonthView.js": [
		63435,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		14451,
		46851,
		40029,
		27508,
		63780,
		88084,
		28669,
		24968,
		97994,
		70776,
		87941,
		75072,
		50993,
		63482,
		99004,
		70727
	],
	"./sport-hub/my/components/FieldCalendar/index": [
		18657,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		14451,
		46851,
		40029,
		27508,
		63780,
		88084,
		28669,
		24968,
		97994,
		70776,
		87941,
		75072,
		50993,
		63482,
		99004,
		45141
	],
	"./sport-hub/my/components/FieldCalendar/index.js": [
		18657,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		14451,
		46851,
		40029,
		27508,
		63780,
		88084,
		28669,
		24968,
		97994,
		70776,
		87941,
		75072,
		50993,
		63482,
		99004,
		45141
	],
	"./sport-hub/my/components/FilterField": [
		15711,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		40793
	],
	"./sport-hub/my/components/FilterField.js": [
		15711,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		40793
	],
	"./sport-hub/my/components/FiltersDrawer": [
		80993,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		46851,
		20025,
		81408,
		40029,
		54590,
		24968,
		32770,
		480
	],
	"./sport-hub/my/components/FiltersDrawer.js": [
		80993,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		46851,
		20025,
		81408,
		40029,
		54590,
		24968,
		32770,
		480
	],
	"./sport-hub/my/components/LevelSlider": [
		48585,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		20025,
		81408,
		54590,
		32908,
		48585
	],
	"./sport-hub/my/components/LevelSlider.js": [
		48585,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		20025,
		81408,
		54590,
		32908,
		48585
	],
	"./sport-hub/my/components/MatchPlayersBadge": [
		11532,
		9,
		11532
	],
	"./sport-hub/my/components/MatchPlayersBadge.js": [
		11532,
		9,
		11532
	],
	"./sport-hub/my/components/MobileSlotSlider": [
		53687,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		20025,
		81408,
		54590,
		95613
	],
	"./sport-hub/my/components/MobileSlotSlider.js": [
		53687,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		20025,
		81408,
		54590,
		95613
	],
	"./sport-hub/my/components/NotificationCenter": [
		49666,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		49666,
		79629
	],
	"./sport-hub/my/components/NotificationCenter.js": [
		49666,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		49666,
		79629
	],
	"./sport-hub/my/components/PadelResultEditor": [
		81334,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		37066,
		43806,
		1902
	],
	"./sport-hub/my/components/PadelResultEditor.js": [
		81334,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		37066,
		43806,
		1902
	],
	"./sport-hub/my/components/PendingChangesActions": [
		15060,
		9,
		4016,
		74556,
		46851,
		41374
	],
	"./sport-hub/my/components/PendingChangesActions.js": [
		15060,
		9,
		4016,
		74556,
		46851,
		41374
	],
	"./sport-hub/my/components/PlayerAvailabilitySection": [
		59298,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		35348,
		40029,
		27508,
		63780,
		75951,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		75072,
		44204
	],
	"./sport-hub/my/components/PlayerAvailabilitySection.js": [
		59298,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		35348,
		40029,
		27508,
		63780,
		75951,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		75072,
		44204
	],
	"./sport-hub/my/components/PlayerCareerPointsTab": [
		39013,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28669,
		24968,
		30154,
		97994,
		10723,
		75072,
		53710
	],
	"./sport-hub/my/components/PlayerCareerPointsTab.js": [
		39013,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28669,
		24968,
		30154,
		97994,
		10723,
		75072,
		53710
	],
	"./sport-hub/my/components/PlayerInfoTab": [
		5759,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		54590,
		27508,
		63780,
		10670,
		30154,
		32908,
		82358
	],
	"./sport-hub/my/components/PlayerInfoTab.js": [
		5759,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		54590,
		27508,
		63780,
		10670,
		30154,
		32908,
		82358
	],
	"./sport-hub/my/components/ReservationCard": [
		46808,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		88084,
		42606
	],
	"./sport-hub/my/components/ReservationCard.js": [
		46808,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		88084,
		42606
	],
	"./sport-hub/my/components/ReservationModal": [
		61048,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		40029,
		54590,
		27508,
		63780,
		10670,
		24968,
		30154,
		10723,
		81400,
		87930
	],
	"./sport-hub/my/components/ReservationModal.js": [
		61048,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		40029,
		54590,
		27508,
		63780,
		10670,
		24968,
		30154,
		10723,
		81400,
		87930
	],
	"./sport-hub/my/components/ShopProductList": [
		67398,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		28669,
		92323,
		70909,
		71698
	],
	"./sport-hub/my/components/ShopProductList.js": [
		67398,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		28669,
		92323,
		70909,
		71698
	],
	"./sport-hub/my/components/SoccerResultEditor": [
		81409,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		98142,
		43806,
		32661
	],
	"./sport-hub/my/components/SoccerResultEditor.js": [
		81409,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		98142,
		43806,
		32661
	],
	"./sport-hub/my/components/SportHubPageContextBar": [
		83775,
		9,
		83775
	],
	"./sport-hub/my/components/SportHubPageContextBar.js": [
		83775,
		9,
		83775
	],
	"./sport-hub/my/components/SportHubPageHeader": [
		2292,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		27508,
		63780,
		28492,
		58118
	],
	"./sport-hub/my/components/SportHubPageHeader.js": [
		2292,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		27508,
		63780,
		28492,
		58118
	],
	"./sport-hub/my/components/SportHubPageShell": [
		85392,
		9,
		58135,
		93288,
		97836,
		48634,
		35348,
		40029,
		75951,
		57933,
		23726
	],
	"./sport-hub/my/components/SportHubPageShell.js": [
		85392,
		9,
		58135,
		93288,
		97836,
		48634,
		35348,
		40029,
		75951,
		57933,
		23726
	],
	"./sport-hub/my/components/SportTypePicker": [
		33714,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		27508,
		63780,
		77909
	],
	"./sport-hub/my/components/SportTypePicker.js": [
		33714,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		27508,
		63780,
		77909
	],
	"./sport-hub/my/components/StatsTab": [
		44565,
		9,
		40029,
		28669,
		14627
	],
	"./sport-hub/my/components/StatsTab.js": [
		44565,
		9,
		40029,
		28669,
		14627
	],
	"./sport-hub/my/components/StructureCollaborators": [
		16884,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		24968,
		30154,
		74066,
		92323,
		19454,
		37218,
		58117,
		13263,
		48803
	],
	"./sport-hub/my/components/StructureCollaborators.js": [
		16884,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		24968,
		30154,
		74066,
		92323,
		19454,
		37218,
		58117,
		13263,
		48803
	],
	"./sport-hub/my/components/StructureInstructors": [
		54573,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		24968,
		30154,
		10723,
		74066,
		92323,
		58117,
		1116
	],
	"./sport-hub/my/components/StructureInstructors.js": [
		54573,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		24968,
		30154,
		10723,
		74066,
		92323,
		58117,
		1116
	],
	"./sport-hub/my/components/TagClienti": [
		88594,
		9,
		58135,
		93288,
		97836,
		48634,
		27508,
		63780,
		5164
	],
	"./sport-hub/my/components/TagClienti.js": [
		88594,
		9,
		58135,
		93288,
		97836,
		48634,
		27508,
		63780,
		5164
	],
	"./sport-hub/my/components/TeamCard": [
		84055,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		58762,
		46819
	],
	"./sport-hub/my/components/TeamCard.js": [
		84055,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		58762,
		46819
	],
	"./sport-hub/my/components/WhatsAppContactAction": [
		99187,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		28492,
		99539
	],
	"./sport-hub/my/components/WhatsAppContactAction.js": [
		99187,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		28492,
		99539
	],
	"./sport-hub/my/components/assistant-v2/AssistantDateSlotNavigator": [
		68484,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		14451,
		46851,
		40029,
		27508,
		63780,
		88084,
		28669,
		24968,
		97994,
		75072,
		50993,
		99004,
		96023
	],
	"./sport-hub/my/components/assistant-v2/AssistantDateSlotNavigator.js": [
		68484,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		14451,
		46851,
		40029,
		27508,
		63780,
		88084,
		28669,
		24968,
		97994,
		75072,
		50993,
		99004,
		96023
	],
	"./sport-hub/my/components/assistant-v2/AssistantOverviewBuilder": [
		71386,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28669,
		24968,
		97994,
		19119,
		32908,
		75072,
		37124,
		50993,
		22370,
		99004,
		70718,
		25802
	],
	"./sport-hub/my/components/assistant-v2/AssistantOverviewBuilder.js": [
		71386,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28669,
		24968,
		97994,
		19119,
		32908,
		75072,
		37124,
		50993,
		22370,
		99004,
		70718,
		25802
	],
	"./sport-hub/my/components/assistant-v2/AssistantOverviewStepContext": [
		88327,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		40029,
		54590,
		27508,
		63780,
		88084,
		28669,
		24968,
		97994,
		75072,
		50993,
		99004,
		24674
	],
	"./sport-hub/my/components/assistant-v2/AssistantOverviewStepContext.js": [
		88327,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		40029,
		54590,
		27508,
		63780,
		88084,
		28669,
		24968,
		97994,
		75072,
		50993,
		99004,
		24674
	],
	"./sport-hub/my/components/assistant-v2/AssistantOverviewStepRecap": [
		5840,
		9,
		58135,
		93288,
		97836,
		48634,
		35348,
		40029,
		75951,
		57933,
		22370,
		99154
	],
	"./sport-hub/my/components/assistant-v2/AssistantOverviewStepRecap.js": [
		5840,
		9,
		58135,
		93288,
		97836,
		48634,
		35348,
		40029,
		75951,
		57933,
		22370,
		99154
	],
	"./sport-hub/my/components/assistant-v2/AssistantPlayersComposer": [
		70718,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		32908,
		9040,
		70718,
		54796
	],
	"./sport-hub/my/components/assistant-v2/AssistantPlayersComposer.js": [
		70718,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		32908,
		9040,
		70718,
		54796
	],
	"./sport-hub/my/components/assistant/SHAssistantLineupProposals": [
		25584,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		25584
	],
	"./sport-hub/my/components/assistant/SHAssistantLineupProposals.js": [
		25584,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		25584
	],
	"./sport-hub/my/components/assistant/SHAssistantMethodCalibrationPanel": [
		92391,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		54590,
		27508,
		63780,
		30154,
		10723,
		32908,
		23224,
		10357,
		92391
	],
	"./sport-hub/my/components/assistant/SHAssistantMethodCalibrationPanel.js": [
		92391,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		54590,
		27508,
		63780,
		30154,
		10723,
		32908,
		23224,
		10357,
		92391
	],
	"./sport-hub/my/components/assistant/SHAssistantPartiteContent": [
		71836,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28669,
		24968,
		97994,
		87941,
		96642,
		32908,
		32770,
		54730,
		5085,
		45684,
		71836
	],
	"./sport-hub/my/components/assistant/SHAssistantPartiteContent.js": [
		71836,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28669,
		24968,
		97994,
		87941,
		96642,
		32908,
		32770,
		54730,
		5085,
		45684,
		71836
	],
	"./sport-hub/my/components/assistant/SHAssistantPartiteDrawer": [
		98247,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28669,
		24968,
		97994,
		87941,
		96642,
		32908,
		32770,
		54730,
		5085,
		45684,
		98247
	],
	"./sport-hub/my/components/assistant/SHAssistantPartiteDrawer.js": [
		98247,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28669,
		24968,
		97994,
		87941,
		96642,
		32908,
		32770,
		54730,
		5085,
		45684,
		98247
	],
	"./sport-hub/my/components/assistant/SHAssistantPartiteFiltersPanel": [
		45684,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		40029,
		54590,
		27508,
		63780,
		10670,
		24968,
		87941,
		96642,
		32908,
		32770,
		45684,
		45820
	],
	"./sport-hub/my/components/assistant/SHAssistantPartiteFiltersPanel.js": [
		45684,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		40029,
		54590,
		27508,
		63780,
		10670,
		24968,
		87941,
		96642,
		32908,
		32770,
		45684,
		45820
	],
	"./sport-hub/my/components/assistant/SHAssistantPlayerSuggestions": [
		19344,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		54590,
		27508,
		63780,
		28669,
		97994,
		58762,
		75072,
		54730,
		70025
	],
	"./sport-hub/my/components/assistant/SHAssistantPlayerSuggestions.js": [
		19344,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		54590,
		27508,
		63780,
		28669,
		97994,
		58762,
		75072,
		54730,
		70025
	],
	"./sport-hub/my/components/assistant/SHAssistantReservationProposals": [
		5099,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		54730,
		8993
	],
	"./sport-hub/my/components/assistant/SHAssistantReservationProposals.js": [
		5099,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		54730,
		8993
	],
	"./sport-hub/my/components/lesson-manager/LessonParticipantsTab": [
		91753,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		78722
	],
	"./sport-hub/my/components/lesson-manager/LessonParticipantsTab.js": [
		91753,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		78722
	],
	"./sport-hub/my/components/match-manager/MatchAssistantInline": [
		19032,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28669,
		24968,
		58762,
		24977
	],
	"./sport-hub/my/components/match-manager/MatchAssistantInline.js": [
		19032,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28669,
		24968,
		58762,
		24977
	],
	"./sport-hub/my/components/match-manager/MatchManagerHeaderCard": [
		85354,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		46851,
		20025,
		81408,
		54590,
		88084,
		85354
	],
	"./sport-hub/my/components/match-manager/MatchManagerHeaderCard.js": [
		85354,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		46851,
		20025,
		81408,
		54590,
		88084,
		85354
	],
	"./sport-hub/my/components/match-manager/MatchNextWeekConfirmationBar": [
		45076,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		45076
	],
	"./sport-hub/my/components/match-manager/MatchNextWeekConfirmationBar.js": [
		45076,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		45076
	],
	"./sport-hub/my/components/match-manager/MatchPaymentAmountModal": [
		60150,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		20025,
		81408,
		40029,
		54590,
		10723,
		74066,
		83095
	],
	"./sport-hub/my/components/match-manager/MatchPaymentAmountModal.js": [
		60150,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		20025,
		81408,
		40029,
		54590,
		10723,
		74066,
		83095
	],
	"./sport-hub/my/components/match-manager/MatchPlayersTab": [
		66302,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		58762,
		55478,
		91721
	],
	"./sport-hub/my/components/match-manager/MatchPlayersTab.js": [
		66302,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		58762,
		55478,
		91721
	],
	"./sport-hub/my/components/match-manager/MatchReservationTab": [
		71175,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		27508,
		63780,
		75951,
		57933,
		10670,
		28669,
		30154,
		52651
	],
	"./sport-hub/my/components/match-manager/MatchReservationTab.js": [
		71175,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		27508,
		63780,
		75951,
		57933,
		10670,
		28669,
		30154,
		52651
	],
	"./sport-hub/my/components/match-manager/MatchResultTab": [
		99398,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		43806,
		21340
	],
	"./sport-hub/my/components/match-manager/MatchResultTab.js": [
		99398,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		43806,
		21340
	],
	"./sport-hub/my/components/overview/DayFieldColumnCard": [
		41286,
		9,
		58135,
		93288,
		97836,
		48634,
		35348,
		40029,
		75951,
		57933,
		88084,
		27136,
		41286
	],
	"./sport-hub/my/components/overview/DayFieldColumnCard.js": [
		41286,
		9,
		58135,
		93288,
		97836,
		48634,
		35348,
		40029,
		75951,
		57933,
		88084,
		27136,
		41286
	],
	"./sport-hub/my/components/overview/SlotBlock": [
		18258,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		45683
	],
	"./sport-hub/my/components/overview/SlotBlock.js": [
		18258,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		45683
	],
	"./sport-hub/my/components/overview/SportHubAvailableMode": [
		6308,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		28492,
		28669,
		24968,
		97994,
		77551,
		70776,
		87941,
		6779,
		75072,
		50993,
		80042,
		99004,
		43839
	],
	"./sport-hub/my/components/overview/SportHubAvailableMode.js": [
		6308,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		28492,
		28669,
		24968,
		97994,
		77551,
		70776,
		87941,
		6779,
		75072,
		50993,
		80042,
		99004,
		43839
	],
	"./sport-hub/my/components/overview/SportHubDayMode": [
		11013,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		14451,
		46851,
		40029,
		27508,
		63780,
		88084,
		28669,
		24968,
		97994,
		70776,
		87941,
		75072,
		50993,
		63482,
		99004,
		11013,
		76541
	],
	"./sport-hub/my/components/overview/SportHubDayMode.js": [
		11013,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		14451,
		46851,
		40029,
		27508,
		63780,
		88084,
		28669,
		24968,
		97994,
		70776,
		87941,
		75072,
		50993,
		63482,
		99004,
		11013,
		76541
	],
	"./sport-hub/my/components/overview/SportHubModeHost": [
		76346,
		9,
		4016,
		74556,
		28669,
		82126
	],
	"./sport-hub/my/components/overview/SportHubModeHost.js": [
		76346,
		9,
		4016,
		74556,
		28669,
		82126
	],
	"./sport-hub/my/components/overview/SportHubNotificationsMode": [
		8623,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		74066,
		6779,
		23224,
		32770,
		89249,
		49666,
		8623,
		46417
	],
	"./sport-hub/my/components/overview/SportHubNotificationsMode.js": [
		8623,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28492,
		28669,
		97994,
		77551,
		70776,
		74066,
		6779,
		23224,
		32770,
		89249,
		49666,
		8623,
		46417
	],
	"./sport-hub/my/components/overview/SportHubOverviewContextPicker": [
		2366,
		9,
		4016,
		74556,
		25980
	],
	"./sport-hub/my/components/overview/SportHubOverviewContextPicker.js": [
		2366,
		9,
		4016,
		74556,
		25980
	],
	"./sport-hub/my/components/overview/SportHubOverviewHeader": [
		61294,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		27508,
		63780,
		28492,
		29703
	],
	"./sport-hub/my/components/overview/SportHubOverviewHeader.js": [
		61294,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		27508,
		63780,
		28492,
		29703
	],
	"./sport-hub/my/components/overview/SportHubOverviewPage": [
		12082,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		70776,
		87941,
		6779,
		92323,
		80042,
		68610,
		47097,
		58117,
		99004,
		11013,
		75394,
		12082,
		26040
	],
	"./sport-hub/my/components/overview/SportHubOverviewPage.js": [
		12082,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		70776,
		87941,
		6779,
		92323,
		80042,
		68610,
		47097,
		58117,
		99004,
		11013,
		75394,
		12082,
		26040
	],
	"./sport-hub/my/components/overview/SportHubStructureInitCard": [
		98025,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		70776,
		6779,
		19119,
		92323,
		68610,
		58117,
		75394,
		1772
	],
	"./sport-hub/my/components/overview/SportHubStructureInitCard.js": [
		98025,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		70776,
		6779,
		19119,
		92323,
		68610,
		58117,
		75394,
		1772
	],
	"./sport-hub/my/components/overview/sportHubModeRegistry": [
		95343,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		28492,
		28669,
		24968,
		97994,
		77551,
		70776,
		87941,
		6779,
		75072,
		50993,
		80042,
		99004,
		11013,
		95821
	],
	"./sport-hub/my/components/overview/sportHubModeRegistry.js": [
		95343,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		28492,
		28669,
		24968,
		97994,
		77551,
		70776,
		87941,
		6779,
		75072,
		50993,
		80042,
		99004,
		11013,
		95821
	],
	"./sport-hub/my/components/overview/useStructureInitFieldsController": [
		75394,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		30154,
		58117,
		75394,
		60444
	],
	"./sport-hub/my/components/overview/useStructureInitFieldsController.js": [
		75394,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		30154,
		58117,
		75394,
		60444
	],
	"./sport-hub/my/components/resource-manager/SimpleReservationResourceManager": [
		29706,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		10723,
		22370,
		21121,
		81400,
		58117,
		85212,
		86406
	],
	"./sport-hub/my/components/resource-manager/SimpleReservationResourceManager.js": [
		29706,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		10723,
		22370,
		21121,
		81400,
		58117,
		85212,
		86406
	],
	"./sport-hub/my/components/settings/SettingsAsideSection": [
		46328,
		9,
		46328
	],
	"./sport-hub/my/components/settings/SettingsAsideSection.js": [
		46328,
		9,
		46328
	],
	"./sport-hub/my/components/settings/SettingsCollaboratorsSection": [
		60537,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		24968,
		30154,
		74066,
		92323,
		19454,
		37218,
		58117,
		13263,
		48309
	],
	"./sport-hub/my/components/settings/SettingsCollaboratorsSection.js": [
		60537,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		24968,
		30154,
		74066,
		92323,
		19454,
		37218,
		58117,
		13263,
		48309
	],
	"./sport-hub/my/components/settings/SettingsFieldFormFields": [
		64743,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		27508,
		63780,
		10670,
		30154,
		10723,
		87809
	],
	"./sport-hub/my/components/settings/SettingsFieldFormFields.js": [
		64743,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		27508,
		63780,
		10670,
		30154,
		10723,
		87809
	],
	"./sport-hub/my/components/settings/SettingsFieldsSection": [
		32626,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		70776,
		6779,
		92323,
		7253
	],
	"./sport-hub/my/components/settings/SettingsFieldsSection.js": [
		32626,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		10723,
		77551,
		70776,
		6779,
		92323,
		7253
	],
	"./sport-hub/my/components/settings/SettingsInstructorsSection": [
		60458,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		24968,
		30154,
		10723,
		74066,
		92323,
		58117,
		57735
	],
	"./sport-hub/my/components/settings/SettingsInstructorsSection.js": [
		60458,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		24968,
		30154,
		10723,
		74066,
		92323,
		58117,
		57735
	],
	"./sport-hub/my/components/settings/SettingsMediaSection": [
		13131,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		19119,
		92323,
		61079,
		78957,
		16747,
		83454
	],
	"./sport-hub/my/components/settings/SettingsMediaSection.js": [
		13131,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		19119,
		92323,
		61079,
		78957,
		16747,
		83454
	],
	"./sport-hub/my/components/settings/SettingsStructureFormFields": [
		88125,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		27508,
		63780,
		10670,
		28669,
		30154,
		78723
	],
	"./sport-hub/my/components/settings/SettingsStructureFormFields.js": [
		88125,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		27508,
		63780,
		10670,
		28669,
		30154,
		78723
	],
	"./sport-hub/my/components/settings/SettingsStructureSection": [
		76731,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28669,
		24968,
		30154,
		20674
	],
	"./sport-hub/my/components/settings/SettingsStructureSection.js": [
		76731,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28669,
		24968,
		30154,
		20674
	],
	"./sport-hub/my/components/settings/SettingsSubscriptionSection": [
		67525,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		28669,
		92323,
		61481,
		63545
	],
	"./sport-hub/my/components/settings/SettingsSubscriptionSection.js": [
		67525,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		28669,
		92323,
		61481,
		63545
	],
	"./sport-hub/my/components/settings/StructureAddressAutocomplete": [
		90084,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		27508,
		63780,
		10670,
		28669,
		74569
	],
	"./sport-hub/my/components/settings/StructureAddressAutocomplete.js": [
		90084,
		9,
		58135,
		93288,
		4016,
		97836,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		27508,
		63780,
		10670,
		28669,
		74569
	],
	"./sport-hub/my/components/settings/settingsCommon": [
		88698,
		9,
		88698
	],
	"./sport-hub/my/components/settings/settingsCommon.js": [
		88698,
		9,
		88698
	],
	"./sport-hub/my/hooks/assistant-v2/useAssistantPlayerCandidates": [
		98310,
		9,
		98310
	],
	"./sport-hub/my/hooks/assistant-v2/useAssistantPlayerCandidates.js": [
		98310,
		9,
		98310
	],
	"./sport-hub/my/hooks/assistant-v2/useAssistantPlayerRanking": [
		33029,
		9,
		33029
	],
	"./sport-hub/my/hooks/assistant-v2/useAssistantPlayerRanking.js": [
		33029,
		9,
		33029
	],
	"./sport-hub/my/hooks/lesson-manager/useLessonParticipantsController": [
		24717,
		9,
		24717
	],
	"./sport-hub/my/hooks/lesson-manager/useLessonParticipantsController.js": [
		24717,
		9,
		24717
	],
	"./sport-hub/my/hooks/match-manager/useMatchAssistantController": [
		53105,
		9,
		53105
	],
	"./sport-hub/my/hooks/match-manager/useMatchAssistantController.js": [
		53105,
		9,
		53105
	],
	"./sport-hub/my/hooks/match-manager/useMatchNextWeekConfirmation": [
		46540,
		9,
		46540
	],
	"./sport-hub/my/hooks/match-manager/useMatchNextWeekConfirmation.js": [
		46540,
		9,
		46540
	],
	"./sport-hub/my/hooks/match-manager/useMatchPlayersController": [
		82838,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		93754
	],
	"./sport-hub/my/hooks/match-manager/useMatchPlayersController.js": [
		82838,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		93754
	],
	"./sport-hub/my/hooks/match-manager/useMatchReservationForm": [
		46059,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		30154,
		24298
	],
	"./sport-hub/my/hooks/match-manager/useMatchReservationForm.js": [
		46059,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		30154,
		24298
	],
	"./sport-hub/my/hooks/useAvailabilityFilter": [
		30017,
		9,
		30017
	],
	"./sport-hub/my/hooks/useAvailabilityFilter.js": [
		30017,
		9,
		30017
	],
	"./sport-hub/my/hooks/useClientiFilters": [
		11412,
		9,
		11412
	],
	"./sport-hub/my/hooks/useClientiFilters.js": [
		11412,
		9,
		11412
	],
	"./sport-hub/my/hooks/useCreatePlayer": [
		59899,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		30154,
		49713
	],
	"./sport-hub/my/hooks/useCreatePlayer.js": [
		59899,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		30154,
		49713
	],
	"./sport-hub/my/hooks/useDeletePlayer": [
		60603,
		9,
		60603
	],
	"./sport-hub/my/hooks/useDeletePlayer.js": [
		60603,
		9,
		60603
	],
	"./sport-hub/my/hooks/useFieldCalendar": [
		93134,
		9,
		88084,
		58117,
		75841,
		87465
	],
	"./sport-hub/my/hooks/useFieldCalendar.js": [
		93134,
		9,
		88084,
		58117,
		75841,
		87465
	],
	"./sport-hub/my/hooks/useMatchPlayersState": [
		28756,
		9,
		28756
	],
	"./sport-hub/my/hooks/useMatchPlayersState.js": [
		28756,
		9,
		28756
	],
	"./sport-hub/my/hooks/useMessageHelpers": [
		23399,
		9,
		46851,
		23399
	],
	"./sport-hub/my/hooks/useMessageHelpers.js": [
		23399,
		9,
		46851,
		23399
	],
	"./sport-hub/my/hooks/usePartiteFilters": [
		65339,
		9,
		65339
	],
	"./sport-hub/my/hooks/usePartiteFilters.js": [
		65339,
		9,
		65339
	],
	"./sport-hub/my/hooks/usePlayerForm": [
		91204,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		30154,
		78874
	],
	"./sport-hub/my/hooks/usePlayerForm.js": [
		91204,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		30154,
		78874
	],
	"./sport-hub/my/hooks/useReservationModal": [
		85212,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		88084,
		30154,
		58117,
		85212,
		32150
	],
	"./sport-hub/my/hooks/useReservationModal.js": [
		85212,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		88084,
		30154,
		58117,
		85212,
		32150
	],
	"./sport-hub/my/hooks/useReservationPlayers": [
		4788,
		9,
		4788
	],
	"./sport-hub/my/hooks/useReservationPlayers.js": [
		4788,
		9,
		4788
	],
	"./sport-hub/my/hooks/useSelectableFields": [
		16602,
		9,
		88084,
		16602
	],
	"./sport-hub/my/hooks/useSelectableFields.js": [
		16602,
		9,
		88084,
		16602
	],
	"./sport-hub/my/hooks/useShAssistantActions": [
		96981,
		9,
		96981
	],
	"./sport-hub/my/hooks/useShAssistantActions.js": [
		96981,
		9,
		96981
	],
	"./sport-hub/my/hooks/useShAssistantContext": [
		36740,
		9,
		36740
	],
	"./sport-hub/my/hooks/useShAssistantContext.js": [
		36740,
		9,
		36740
	],
	"./sport-hub/my/hooks/useShAssistantPartiteCalibration": [
		85417,
		9,
		85417
	],
	"./sport-hub/my/hooks/useShAssistantPartiteCalibration.js": [
		85417,
		9,
		85417
	],
	"./sport-hub/my/hooks/useShAssistantPartiteFilters": [
		94582,
		9,
		94582
	],
	"./sport-hub/my/hooks/useShAssistantPartiteFilters.js": [
		94582,
		9,
		94582
	],
	"./sport-hub/my/hooks/useShAssistantSuggestions": [
		33193,
		9,
		33193
	],
	"./sport-hub/my/hooks/useShAssistantSuggestions.js": [
		33193,
		9,
		33193
	],
	"./sport-hub/my/hooks/useSportHubDayModeHorizontalViewport": [
		78054,
		9,
		78054
	],
	"./sport-hub/my/hooks/useSportHubDayModeHorizontalViewport.js": [
		78054,
		9,
		78054
	],
	"./sport-hub/my/hooks/useSportHubDayModeMobileFieldNavigation": [
		76928,
		9,
		76928
	],
	"./sport-hub/my/hooks/useSportHubDayModeMobileFieldNavigation.js": [
		76928,
		9,
		76928
	],
	"./sport-hub/my/hooks/useSportHubDayModeScrollController": [
		85911,
		9,
		88084,
		85911
	],
	"./sport-hub/my/hooks/useSportHubDayModeScrollController.js": [
		85911,
		9,
		88084,
		85911
	],
	"./sport-hub/my/hooks/useSportHubDaySlotShellOverflow": [
		71469,
		9,
		71469
	],
	"./sport-hub/my/hooks/useSportHubDaySlotShellOverflow.js": [
		71469,
		9,
		71469
	],
	"./sport-hub/my/hooks/useSportHubFeatureFlags": [
		64560,
		9,
		64560
	],
	"./sport-hub/my/hooks/useSportHubFeatureFlags.js": [
		64560,
		9,
		64560
	],
	"./sport-hub/my/hooks/useSportHubGlobalSportContext": [
		67849,
		9,
		67849
	],
	"./sport-hub/my/hooks/useSportHubGlobalSportContext.js": [
		67849,
		9,
		67849
	],
	"./sport-hub/my/hooks/useSportHubModeTransition": [
		91062,
		9,
		91062
	],
	"./sport-hub/my/hooks/useSportHubModeTransition.js": [
		91062,
		9,
		91062
	],
	"./sport-hub/my/hooks/useSportHubOverview": [
		75841,
		9,
		88084,
		75841,
		38412
	],
	"./sport-hub/my/hooks/useSportHubOverview.js": [
		75841,
		9,
		88084,
		75841,
		38412
	],
	"./sport-hub/my/hooks/useSportHubOverviewController": [
		52639,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		88084,
		30154,
		74066,
		58117,
		29475,
		85212,
		5362,
		75841,
		52639,
		64791
	],
	"./sport-hub/my/hooks/useSportHubOverviewController.js": [
		52639,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		88084,
		30154,
		74066,
		58117,
		29475,
		85212,
		5362,
		75841,
		52639,
		64791
	],
	"./sport-hub/my/hooks/useSportHubOverviewSelectionController": [
		83608,
		9,
		88084,
		83608
	],
	"./sport-hub/my/hooks/useSportHubOverviewSelectionController.js": [
		83608,
		9,
		88084,
		83608
	],
	"./sport-hub/my/hooks/useSportHubSettingsController": [
		20268,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		30154,
		58117,
		83673
	],
	"./sport-hub/my/hooks/useSportHubSettingsController.js": [
		20268,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		30154,
		58117,
		83673
	],
	"./sport-hub/my/hooks/useSportHubSettingsData": [
		88118,
		9,
		88084,
		88118
	],
	"./sport-hub/my/hooks/useSportHubSettingsData.js": [
		88118,
		9,
		88084,
		88118
	],
	"./sport-hub/my/hooks/useSportHubStructureSelection": [
		79378,
		9,
		79378
	],
	"./sport-hub/my/hooks/useSportHubStructureSelection.js": [
		79378,
		9,
		79378
	],
	"./sport-hub/my/hooks/useSwipe": [
		71131,
		9,
		71131
	],
	"./sport-hub/my/hooks/useSwipe.js": [
		71131,
		9,
		71131
	],
	"./sport-hub/my/navigation": [
		21488,
		9
	],
	"./sport-hub/my/navigation.js": [
		21488,
		9
	],
	"./sport-hub/my/utils/assistant/lineupMerge": [
		6928,
		9,
		6928
	],
	"./sport-hub/my/utils/assistant/lineupMerge.js": [
		6928,
		9,
		6928
	],
	"./sport-hub/my/utils/assistant/suggestionRanking": [
		73533,
		9,
		73533
	],
	"./sport-hub/my/utils/assistant/suggestionRanking.js": [
		73533,
		9,
		73533
	],
	"./sport-hub/my/utils/availabilityMatching": [
		64175,
		9,
		64175
	],
	"./sport-hub/my/utils/availabilityMatching.js": [
		64175,
		9,
		64175
	],
	"./sport-hub/my/utils/clientTags": [
		57142,
		9,
		57142
	],
	"./sport-hub/my/utils/clientTags.js": [
		57142,
		9,
		57142
	],
	"./sport-hub/my/utils/csvExport": [
		7579,
		9,
		7579
	],
	"./sport-hub/my/utils/csvExport.js": [
		7579,
		9,
		7579
	],
	"./sport-hub/my/utils/dayModeFieldTiming": [
		94100,
		9,
		88084,
		94100
	],
	"./sport-hub/my/utils/dayModeFieldTiming.js": [
		94100,
		9,
		88084,
		94100
	],
	"./sport-hub/my/utils/dayModeTimeline": [
		74805,
		9,
		88084,
		74805
	],
	"./sport-hub/my/utils/dayModeTimeline.js": [
		74805,
		9,
		88084,
		74805
	],
	"./sport-hub/my/utils/dayModeViewport": [
		14070,
		9,
		14070
	],
	"./sport-hub/my/utils/dayModeViewport.js": [
		14070,
		9,
		14070
	],
	"./sport-hub/my/utils/fieldDuplicate": [
		23805,
		9,
		23805
	],
	"./sport-hub/my/utils/fieldDuplicate.js": [
		23805,
		9,
		23805
	],
	"./sport-hub/my/utils/fieldUtils": [
		17083,
		9,
		88084,
		17083
	],
	"./sport-hub/my/utils/fieldUtils.js": [
		17083,
		9,
		88084,
		17083
	],
	"./sport-hub/my/utils/matchSlots": [
		18466,
		9,
		18466
	],
	"./sport-hub/my/utils/matchSlots.js": [
		18466,
		9,
		18466
	],
	"./sport-hub/my/utils/overviewAssistant": [
		94763,
		9,
		88084,
		94763
	],
	"./sport-hub/my/utils/overviewAssistant.js": [
		94763,
		9,
		88084,
		94763
	],
	"./sport-hub/my/utils/overviewAvailableModeModel": [
		22630,
		9,
		22630
	],
	"./sport-hub/my/utils/overviewAvailableModeModel.js": [
		22630,
		9,
		22630
	],
	"./sport-hub/my/utils/overviewDayMode": [
		99014,
		9,
		88084,
		99014
	],
	"./sport-hub/my/utils/overviewDayMode.js": [
		99014,
		9,
		88084,
		99014
	],
	"./sport-hub/my/utils/overviewDayModeModel": [
		73074,
		9,
		88084,
		73074
	],
	"./sport-hub/my/utils/overviewDayModeModel.js": [
		73074,
		9,
		88084,
		73074
	],
	"./sport-hub/my/utils/overviewHeaderModel": [
		85900,
		9,
		85900
	],
	"./sport-hub/my/utils/overviewHeaderModel.js": [
		85900,
		9,
		85900
	],
	"./sport-hub/my/utils/overviewHelpers": [
		17303,
		9,
		17303
	],
	"./sport-hub/my/utils/overviewHelpers.js": [
		17303,
		9,
		17303
	],
	"./sport-hub/my/utils/overviewModePolicy": [
		21491,
		9,
		88084,
		21491
	],
	"./sport-hub/my/utils/overviewModePolicy.js": [
		21491,
		9,
		88084,
		21491
	],
	"./sport-hub/my/utils/paymentWindow": [
		79686,
		9,
		79686
	],
	"./sport-hub/my/utils/paymentWindow.js": [
		79686,
		9,
		79686
	],
	"./sport-hub/my/utils/playerAutocomplete": [
		34743,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		7342
	],
	"./sport-hub/my/utils/playerAutocomplete.js": [
		34743,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		7342
	],
	"./sport-hub/my/utils/renderListItem": [
		20652,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		88084,
		20652
	],
	"./sport-hub/my/utils/renderListItem.js": [
		20652,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		88084,
		20652
	],
	"./sport-hub/my/utils/sportTypeDisplay": [
		30712,
		9,
		30712
	],
	"./sport-hub/my/utils/sportTypeDisplay.js": [
		30712,
		9,
		30712
	],
	"./sport-hub/my/utils/whatsappContactAction": [
		79486,
		9,
		79486
	],
	"./sport-hub/my/utils/whatsappContactAction.js": [
		79486,
		9,
		79486
	],
	"./sport-hub/test/jest.config.cjs": [
		12831,
		1,
		12831
	],
	"./sport-hub/translation/en": [
		410,
		3
	],
	"./sport-hub/translation/en.json": [
		410,
		3
	],
	"./sport-hub/translation/it": [
		82119,
		3
	],
	"./sport-hub/translation/it.json": [
		82119,
		3
	],
	"./sport-hub/utils/fieldResource": [
		70678,
		9,
		70678
	],
	"./sport-hub/utils/fieldResource.js": [
		70678,
		9,
		70678
	],
	"./sport-hub/utils/media": [
		75388,
		9,
		75388
	],
	"./sport-hub/utils/media.js": [
		75388,
		9,
		75388
	],
	"./sport-hub/utils/moduleAccess": [
		31597,
		9
	],
	"./sport-hub/utils/moduleAccess.js": [
		31597,
		9
	],
	"./sport-hub/utils/reservationSport": [
		30263,
		9,
		30263
	],
	"./sport-hub/utils/reservationSport.js": [
		30263,
		9,
		30263
	],
	"./sport-hub/utils/reservationType": [
		79629,
		9,
		77575
	],
	"./sport-hub/utils/reservationType.js": [
		79629,
		9,
		77575
	],
	"./sport-hub/utils/urlBuilder": [
		57749,
		9
	],
	"./sport-hub/utils/urlBuilder.js": [
		57749,
		9
	],
	"./sport-hub/web": [
		36737,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		58762,
		77551,
		87941,
		12696,
		96642,
		92323,
		79016,
		40155,
		36600,
		63316,
		29114
	],
	"./sport-hub/web/": [
		36737,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		58762,
		77551,
		87941,
		12696,
		96642,
		92323,
		79016,
		40155,
		36600,
		63316,
		29114
	],
	"./sport-hub/web/Emitters": [
		99665,
		9,
		99665
	],
	"./sport-hub/web/Emitters.js": [
		99665,
		9,
		99665
	],
	"./sport-hub/web/PublicMatch": [
		36600,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		58762,
		50993,
		56662,
		48361,
		54543,
		43806,
		16005,
		36600,
		27561
	],
	"./sport-hub/web/PublicMatch.js": [
		36600,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		28492,
		28669,
		24968,
		58762,
		50993,
		56662,
		48361,
		54543,
		43806,
		16005,
		36600,
		27561
	],
	"./sport-hub/web/PublicMatchResultEdit": [
		20107,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		46851,
		20025,
		81408,
		54590,
		28669,
		58762,
		43806,
		16005,
		54845
	],
	"./sport-hub/web/PublicMatchResultEdit.js": [
		20107,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		46851,
		20025,
		81408,
		54590,
		28669,
		58762,
		43806,
		16005,
		54845
	],
	"./sport-hub/web/PublicPage": [
		44665,
		9,
		12696,
		61300,
		44665
	],
	"./sport-hub/web/PublicPage.js": [
		44665,
		9,
		12696,
		61300,
		44665
	],
	"./sport-hub/web/PublicPlayerNotifications": [
		96454,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28669,
		97994,
		77551,
		75072,
		32770,
		55391,
		64204
	],
	"./sport-hub/web/PublicPlayerNotifications.js": [
		96454,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28669,
		97994,
		77551,
		75072,
		32770,
		55391,
		64204
	],
	"./sport-hub/web/PublicPlayerPage": [
		31311,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28669,
		97994,
		77551,
		12696,
		75072,
		32770,
		55391,
		70773
	],
	"./sport-hub/web/PublicPlayerPage.js": [
		31311,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		28669,
		97994,
		77551,
		12696,
		75072,
		32770,
		55391,
		70773
	],
	"./sport-hub/web/StructurePublicPage": [
		68940,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		75951,
		57933,
		88084,
		10670,
		28492,
		24968,
		30154,
		58762,
		87941,
		96642,
		92323,
		56662,
		79016,
		16005,
		63316,
		40886
	],
	"./sport-hub/web/StructurePublicPage.js": [
		68940,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		75951,
		57933,
		88084,
		10670,
		28492,
		24968,
		30154,
		58762,
		87941,
		96642,
		92323,
		56662,
		79016,
		16005,
		63316,
		40886
	],
	"./sport-hub/web/components/ListViewer": [
		9815,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		58762,
		94676
	],
	"./sport-hub/web/components/ListViewer.js": [
		9815,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		10670,
		58762,
		94676
	],
	"./sport-hub/web/components/PlayerClaimRecovery": [
		66453,
		9,
		58135,
		93288,
		4016,
		74556,
		14451,
		20025,
		81408,
		10670,
		48361,
		82600
	],
	"./sport-hub/web/components/PlayerClaimRecovery.js": [
		66453,
		9,
		58135,
		93288,
		4016,
		74556,
		14451,
		20025,
		81408,
		10670,
		48361,
		82600
	],
	"./sport-hub/web/components/PublicFooter": [
		89128,
		9,
		89128
	],
	"./sport-hub/web/components/PublicFooter.js": [
		89128,
		9,
		89128
	],
	"./sport-hub/web/components/ResultEditors": [
		12602,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		58980,
		43806,
		53642
	],
	"./sport-hub/web/components/ResultEditors.js": [
		12602,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		58980,
		43806,
		53642
	],
	"./sport-hub/web/components/ResultView": [
		13222,
		9,
		13222
	],
	"./sport-hub/web/components/ResultView.js": [
		13222,
		9,
		13222
	],
	"./sport-hub/web/components/ResultViewer": [
		5708,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		2515,
		43806,
		16369
	],
	"./sport-hub/web/components/ResultViewer.js": [
		5708,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		2515,
		43806,
		16369
	],
	"./sport-hub/web/components/SportHubHeader": [
		93151,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		54590,
		28492,
		58762,
		56662,
		49489
	],
	"./sport-hub/web/components/SportHubHeader.js": [
		93151,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		54590,
		28492,
		58762,
		56662,
		49489
	],
	"./sport-hub/web/components/TeamViewer": [
		98734,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		36996,
		43806,
		50246
	],
	"./sport-hub/web/components/TeamViewer.js": [
		98734,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		46851,
		58762,
		36996,
		43806,
		50246
	],
	"./sport-hub/web/components/padel/PadelResultView": [
		70605,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		70605
	],
	"./sport-hub/web/components/padel/PadelResultView.jsx": [
		70605,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		20025,
		81408,
		35348,
		40029,
		54590,
		75951,
		57933,
		70605
	],
	"./sport-hub/web/components/padel/PadelRisultatoModal": [
		99588,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		20025,
		81408,
		40029,
		54590,
		24968,
		10723,
		83285
	],
	"./sport-hub/web/components/padel/PadelRisultatoModal.jsx": [
		99588,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		20025,
		81408,
		40029,
		54590,
		24968,
		10723,
		83285
	],
	"./sport-hub/web/components/padel/ResultView": [
		27232,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		69693
	],
	"./sport-hub/web/components/padel/ResultView.js": [
		27232,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		14451,
		20025,
		81408,
		54590,
		69693
	],
	"./sport-hub/web/components/padel/TeamViewPadel": [
		42121,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		46851,
		58762,
		99497
	],
	"./sport-hub/web/components/padel/TeamViewPadel.js": [
		42121,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		46851,
		58762,
		99497
	],
	"./sport-hub/web/components/soccer/ResultView": [
		80587,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		20025,
		81408,
		54590,
		80587
	],
	"./sport-hub/web/components/soccer/ResultView.js": [
		80587,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		20025,
		81408,
		54590,
		80587
	],
	"./sport-hub/web/components/soccer/RisultatoModal": [
		90383,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		20025,
		81408,
		40029,
		54590,
		24968,
		35536
	],
	"./sport-hub/web/components/soccer/RisultatoModal.js": [
		90383,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		14451,
		20025,
		81408,
		40029,
		54590,
		24968,
		35536
	],
	"./sport-hub/web/components/soccer/TeamView": [
		85896,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		46851,
		58762,
		48257
	],
	"./sport-hub/web/components/soccer/TeamView.js": [
		85896,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		46851,
		58762,
		48257
	],
	"./sport-hub/web/index": [
		36737,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		58762,
		77551,
		87941,
		12696,
		96642,
		92323,
		79016,
		40155,
		36600,
		63316,
		29114
	],
	"./sport-hub/web/index.js": [
		36737,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		54590,
		27508,
		63780,
		75951,
		57933,
		88084,
		10670,
		28492,
		28669,
		24968,
		30154,
		97994,
		58762,
		77551,
		87941,
		12696,
		96642,
		92323,
		79016,
		40155,
		36600,
		63316,
		29114
	],
	"./sport-hub/web/publicPage.scss": [
		47040,
		9,
		16005,
		47040
	],
	"./sport-hub/web/utils/portalTokenStorage": [
		8392,
		9,
		8392
	],
	"./sport-hub/web/utils/portalTokenStorage.js": [
		8392,
		9,
		8392
	],
	"./waitress-order-ticket/client/assets/images/thumbnail.jpg": [
		60371,
		1,
		60371
	],
	"./waitress-order-ticket/client/graphql/device": [
		7583,
		9,
		7583
	],
	"./waitress-order-ticket/client/graphql/device.js": [
		7583,
		9,
		7583
	],
	"./waitress-order-ticket/client/graphql/settings": [
		92110,
		9
	],
	"./waitress-order-ticket/client/graphql/settings.js": [
		92110,
		9
	],
	"./waitress-order-ticket/client/scss/NavsAsideExtends.scss": [
		21469,
		9
	],
	"./waitress-order-ticket/client/scss/device.scss": [
		84799,
		9,
		84799
	],
	"./waitress-order-ticket/client/scss/index.scss": [
		11538,
		9
	],
	"./waitress-order-ticket/client/scss/publicPage.scss": [
		71986,
		9,
		71986
	],
	"./waitress-order-ticket/client/typePolicies": [
		93851,
		9,
		93851
	],
	"./waitress-order-ticket/client/typePolicies.js": [
		93851,
		9,
		93851
	],
	"./waitress-order-ticket/components/Device": [
		55460,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		75951,
		88084,
		10670,
		28492,
		74066,
		95500,
		20711,
		19454,
		87258,
		14339,
		99950,
		55460
	],
	"./waitress-order-ticket/components/Device.js": [
		55460,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		75951,
		88084,
		10670,
		28492,
		74066,
		95500,
		20711,
		19454,
		87258,
		14339,
		99950,
		55460
	],
	"./waitress-order-ticket/components/DevicePage": [
		4276,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		75951,
		88084,
		10670,
		28492,
		74066,
		95500,
		20711,
		19454,
		87258,
		14339,
		99950,
		4276,
		20165
	],
	"./waitress-order-ticket/components/DevicePage.js": [
		4276,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		75951,
		88084,
		10670,
		28492,
		74066,
		95500,
		20711,
		19454,
		87258,
		14339,
		99950,
		4276,
		20165
	],
	"./waitress-order-ticket/components/DeviceTabDetails": [
		25364,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		88084,
		28492,
		87258,
		68050
	],
	"./waitress-order-ticket/components/DeviceTabDetails.js": [
		25364,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		88084,
		28492,
		87258,
		68050
	],
	"./waitress-order-ticket/components/DeviceTabHeader": [
		94760,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		28492,
		87258,
		94760
	],
	"./waitress-order-ticket/components/DeviceTabHeader.js": [
		94760,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		28492,
		87258,
		94760
	],
	"./waitress-order-ticket/components/DeviceTabOrder": [
		99950,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		28492,
		95500,
		20711,
		87258,
		99950
	],
	"./waitress-order-ticket/components/DeviceTabOrder.js": [
		99950,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		46851,
		35348,
		28492,
		95500,
		20711,
		87258,
		99950
	],
	"./waitress-order-ticket/components/Devices": [
		2966,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		75951,
		88084,
		10670,
		28492,
		74066,
		95500,
		20711,
		19454,
		87258,
		14339,
		99950,
		2966
	],
	"./waitress-order-ticket/components/Devices.js": [
		2966,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		75951,
		88084,
		10670,
		28492,
		74066,
		95500,
		20711,
		19454,
		87258,
		14339,
		99950,
		2966
	],
	"./waitress-order-ticket/module": [
		96685,
		3
	],
	"./waitress-order-ticket/module.json": [
		96685,
		3
	],
	"./waitress-order-ticket/my/Dashboard": [
		70267,
		9,
		70267
	],
	"./waitress-order-ticket/my/Dashboard.js": [
		70267,
		9,
		70267
	],
	"./waitress-order-ticket/my/Emitters": [
		95908,
		9,
		95908
	],
	"./waitress-order-ticket/my/Emitters.js": [
		95908,
		9,
		95908
	],
	"./waitress-order-ticket/my/NavsAsideExtends": [
		83969,
		9
	],
	"./waitress-order-ticket/my/NavsAsideExtends.js": [
		83969,
		9
	],
	"./waitress-order-ticket/my/Settings": [
		28811,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		27508,
		63780,
		10670,
		28492,
		20711,
		32289,
		28811
	],
	"./waitress-order-ticket/my/Settings.js": [
		28811,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		27508,
		63780,
		10670,
		28492,
		20711,
		32289,
		28811
	],
	"./waitress-order-ticket/my/WaitressOrderTicket": [
		40818,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		75951,
		88084,
		10670,
		28492,
		74066,
		95500,
		20711,
		19454,
		87258,
		14339,
		99950,
		4276,
		29436
	],
	"./waitress-order-ticket/my/WaitressOrderTicket.js": [
		40818,
		9,
		58135,
		93288,
		4016,
		97836,
		3048,
		74556,
		48634,
		14451,
		46851,
		20025,
		81408,
		35348,
		40029,
		75951,
		88084,
		10670,
		28492,
		74066,
		95500,
		20711,
		19454,
		87258,
		14339,
		99950,
		4276,
		29436
	],
	"./waitress-order-ticket/translation/en": [
		53923,
		3
	],
	"./waitress-order-ticket/translation/en.json": [
		53923,
		3
	],
	"./waitress-order-ticket/translation/it": [
		5249,
		3
	],
	"./waitress-order-ticket/translation/it.json": [
		5249,
		3
	],
	"./waitress-order-ticket/web": [
		48755,
		9,
		12696,
		48755
	],
	"./waitress-order-ticket/web/": [
		48755,
		9,
		12696,
		48755
	],
	"./waitress-order-ticket/web/Emitters": [
		41015,
		9,
		41015
	],
	"./waitress-order-ticket/web/Emitters.js": [
		41015,
		9,
		41015
	],
	"./waitress-order-ticket/web/PublicPage": [
		84263,
		9,
		12696,
		84263
	],
	"./waitress-order-ticket/web/PublicPage.js": [
		84263,
		9,
		12696,
		84263
	],
	"./waitress-order-ticket/web/index": [
		48755,
		9,
		12696,
		48755
	],
	"./waitress-order-ticket/web/index.js": [
		48755,
		9,
		12696,
		48755
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 93820;
module.exports = webpackAsyncContext;